angular.module('commonData', []).service('$commonDataService', ['$http', '$timeout', '$q', function ($http, $timeout, $q) {
   
    this.saleTypes = [{
        "label": "CVC",
        "value": "1"
    },{
        "label": "Agência",
        "value": "2"
    }];
    
    this.insuranceTypes = [{
        "label": "Perda e roubo + dívida familiar",
        "value": "01;03;03;01;03;Perda e Roubo + Divida familiar;null;3.99"
    },{
        "label": "Perda e roubo",
        "value": "08;01;08;08;08;Perda e Roubo;null;2"
    }];
    
    this.tipos_logradouro = [{
        "label": "Acesso"
    },{
        "label": "Aeroporto"
    },{
        "label": "Alameda"
    },{
        "label": "Avenida"
    },{
        "label": "BR"
    },{
        "label": "Beco"
    },{
        "label": "Bloco"
    },{
        "label": "Caminho"
    },{
        "label": "Campo"
    },{
        "label": "Chácara"
    },{
        "label": "Colônia"
    },{
        "label": "Condomínio"
    },{
        "label": "Conjunto"
    },{
        "label": "Distrito"
    },{
        "label": "Esplanada"
    },{
        "label": "Estação"
    },{
        "label": "Estrada"
    },{
        "label": "Favela"
    },{
        "label": "Fazenda"
    },{
        "label": "Feira"
    },{
        "label": "Jardim"
    },{
        "label": "Ladeira"
    },{
        "label": "Lago"
    },{
        "label": "Lagoa"
    },{
        "label": "Largo"
    },{
        "label": "Linha"
    },{
        "label": "Loteamento"
    },{
        "label": "Morro"
    },{
        "label": "Núcleo"
    },{
        "label": "Parque"
    },{
        "label": "Passagem"
    },{
        "label": "Passarela"
    },{
        "label": "Passeio"
    },{
        "label": "Praça"
    },{
        "label": "Pátio"
    },{
        "label": "Quadra"
    },{
        "label": "Ramal"
    },{
        "label": "Recanto"
    },{
        "label": "Residencial"
    },{
        "label": "Rodovia"
    },{
        "label": "Rua"
    },{
        "label": "Setor"
    },{
        "label": "Subida"
    },{
        "label": "Sítio"
    },{
        "label": "Travessa"
    },{
        "label": "Travessia"
    },{
        "label": "Trecho"
    },{
        "label": "Trevo"
    },{
        "label": "Vale"
    },{
        "label": "Vereda"
    },{
        "label": "Via"
    },{
        "label": "Viaduto"
    },{
        "label": "Viela"
    },{
        "label": "Vila"
    },{
        "label": "Área"
    }];
    
    this.accountTypes = [{
        "label": "Conta corrente",
        "value": "C"
    },{
        "label": "Conta poupança",
        "value": "P"
    },{
        "label": "Não possui",
        "value": "N"
    }];
    
    this.proposalStatus = [{
        "label": "Pendente",
        "value": "1"
    },{
        "label": "Negada",
        "value": "2"
    },{
        "label": "Aprovada",
        "value": "3"
    },{
        "label": "Cancelada",
        "value": "4"
    },{
        "label": "Liberada",
        "value": "5"
    }];
    
    this.bankStatus = [{
        "label": "Pendente",
        "value": "1"
    },{
        "label": "Negada",
        "value": "2"
    },{
        "label": "Aprovada",
        "value": "3"
    }];

    this.CNPJDocumentTypes = [{
        "label": "EIN",
        "value": "7"
    }, {
        "label": "RUT",
        "value": "9"
    }, {
        "label": "RUC",
        "value": "10"
    }, {
        "label": "CUIT",
        "value": "11"
    }];

    this.documentTypes = [{
        "label": "Passaporte",
        "value": "1"
    }, {
        "label": "CPF",
        "value": "2"
    }];

    this.departureLocations = [
        { value: 9626, label: 'SP - São Paulo', state: 'SP' },
        { value: 322, label: 'AM - Manaus', state: 'AM' },
        { value: 1076, label: 'BA - Salvador', state: 'BA' },
        { value: 1463, label: 'CE - Fortaleza', state: 'CE' },
        { value: 1911, label: 'DF - Brasília', state: 'DF' },
        { value: 2181, label: 'ES - Vitória', state: 'ES' },
        { value: 2330, label: 'GO - Goiânia', state: 'GO' },
        { value: 2920, label: 'MG - Belo Horizonte', state: 'MG' },
        { value: 4214, label: 'MG - Uberlândia', state: 'MG' },
        { value: 4349, label: 'MS - Campo Grande', state: 'MS' },
        { value: 4462, label: 'MT - Cuiabá', state: 'MT' },
        { value: 4693, label: 'PA - Belém', state: 'PA' },
        { value: 5104, label: 'PB - João Pessoa', state: 'PB' },
        { value: 5541, label: 'PE - Recife', state: 'PE' },
        { value: 5871, label: 'PI - Teresina', state: 'PI' },
        { value: 6162, label: 'PR - Curitiba', state: 'PR' },
        { value: 6236, label: 'PR - Foz do Iguaçu', state: 'PR' },
        { value: 6412, label: 'PR - Londrina', state: 'PR' },
        { value: 6452, label: 'PR - Maringá', state: 'PR' },
        { value: 7110, label: 'RJ - Rio de Janeiro', state: 'RJ' },
        { value: 8002, label: 'RS - Porto Alegre', state: 'RS' },
        { value: 8400, label: 'SC - Florianópolis', state: 'SC' },
        { value: 8726, label: 'SE - Aracajú', state: 'SE' },
        { value: 8919, label: 'SP - Baurú', state: 'SP' },
        { value: 8983, label: 'SP - Campinas', state: 'SP' },
        { value: 9518, label: 'SP - Ribeirão Preto', state: 'SP' },
        { value: 9617, label: 'SP - São José do Rio Preto', state: 'SP' },
        { value: 34584, label: 'RN - Natal', state: 'RN' }
    ];

    this.states = [{
        "description": "Acre",
        "label": "AC",
        "value": "AC"
    }, {
        "description": "Alagoas",
        "label": "AL",
        "value": "AL"
    }, {
        "description": "Amapá",
        "label": "AP",
        "value": "AP"
    }, {
        "description": "Amazonas",
        "label": "AM",
        "value": "AM"
    }, {
        "description": "Bahia",
        "label": "BA",
        "value": "BA"
    }, {
        "description": "Ceará",
        "label": "CE",
        "value": "CE"
    }, {
        "description": "Distríto Federal",
        "label": "DF",
        "value": "DF"
    }, {
        "description": "Espiríto Santo",
        "label": "ES",
        "value": "ES"
    }, {
        "description": "Goiás",
        "label": "GO",
        "value": "GO"
    }, {
        "description": "Maranhão",
        "label": "MA",
        "value": "MA"
    }, {
        "description": "Mato Grosso do Sul",
        "label": "MS",
        "value": "MS"
    }, {
        "description": "Mato Grosso",
        "label": "MT",
        "value": "MT"
    }, {
        "description": "Minas Gerais",
        "label": "MG",
        "value": "MG"
    }, {
        "description": "Pará",
        "label": "PA",
        "value": "PA"
    }, {
        "description": "Paraíba",
        "label": "PB",
        "value": "PB"
    }, {
        "description": "Paraná",
        "label": "PR",
        "value": "PR"
    }, {
        "description": "Pernambuco",
        "label": "PE",
        "value": "PE"
    }, {
        "description": "Piauí",
        "label": "PI",
        "value": "PI"
    }, {
        "description": "Rio de Janeiro",
        "label": "RJ",
        "value": "RJ"
    }, {
        "description": "Rio Grande do Norte",
        "label": "RN",
        "value": "RN"
    }, {
        "description": "Rio Grande do Sul",
        "label": "RS",
        "value": "RS"
    }, {
        "description": "Rondônia",
        "label": "RO",
        "value": "RO"
    }, {
        "description": "Roraima",
        "label": "RR",
        "value": "RR"
    }, {
        "description": "Santa Catarina",
        "label": "SC",
        "value": "SC"
    }, {
        "description": "São Paulo",
        "label": "SP",
        "value": "SP"
    }, {
        "description": "Sergipe",
        "label": "SE",
        "value": "SE"
    }, {
        "description": "Tocantins",
        "label": "TO",
        "value": "TO"
    }];

    this.educationTypes = [{
        label: 'Ensino Fundamental Incompleto', value: 1
    }, {
        label : 'Ensino Fundamental Completo', value : 2
    },{
        label : 'Ensino Médio Incompleto', value : 3
    },{
        label : 'Ensino Médio Completo', value : 4
    },{
        label : 'Ensino Superior Incompleto', value : 5
    },{
        label : 'Ensino Superior Completo', value : 6
    },{
        label : 'Pós-Graduação', value : 7
    },{
        label : 'Mestrado', value : 8
    },{
        label : 'Doutorado', value : 9
    },{
        label : 'Nenhum', value : 10
    },{
        label : 'Analfabeto', value : 11
    },{
        label : 'Educação Básica Incompleta', value : 12
    },{
        label : 'Educação Básica Completa', value : 13
    },{
        label : 'MBA', value : 14
    },{
        label : 'PHD', value : 15
    },{
        label : 'Pós-Graduação Incompleta', value : 16
    },{
        label : 'Mestrado Incompleto', value : 17
    },{
        label : 'Doutorado Incompleto', value : 18
    },{
        label : 'Pós-Doutorado Incompleto', value : 19
    },{
        label : 'Notório Saber', value : 20
    }];

    this.roles = [{
        "label": " Adestrador de animais ",
        "value": 854
    }, {
        "label": " Administrador ",
        "value": 855
    }, {
        "label": "Abatedor ",
        "value": 849
    }, {
        "label": "Acabador de calçados ",
        "value": 850
    }, {
        "label": "Açougueiro ",
        "value": 851
    }, {
        "label": "Acrobata ",
        "value": 852
    }, {
        "label": "Acupunturista ",
        "value": 853
    }, {
        "label": "Administrador de edifícios ",
        "value": 856
    }, {
        "label": "ADMINISTRADOR DE REDES NT",
        "value": 549
    }, {
        "label": "ADMINITRADOR BANCO DADOS",
        "value": 744
    }, {
        "label": "ADVOGADO",
        "value": 810
    }, {
        "label": "ADVOGADO JR",
        "value": 694
    }, {
        "label": "ADVOGADO PL",
        "value": 695
    }, {
        "label": "ADVOGADO SR",
        "value": 696
    }, {
        "label": "Agenciador de propaganda ",
        "value": 857
    }, {
        "label": "Agente de higiene e segurança ",
        "value": 858
    }, {
        "label": "Agente de trânsito ",
        "value": 859
    }, {
        "label": "Agente publicitário ",
        "value": 860
    }, {
        "label": "Agricultor",
        "value": 862
    }, {
        "label": "Agrônomo ",
        "value": 861
    }, {
        "label": "Alfaiate ",
        "value": 865
    }, {
        "label": "ALMOXARIFE",
        "value": 9
    }, {
        "label": "Almoxarife ",
        "value": 866
    }, {
        "label": "ANALISTA  REMUNERAÇÃO E BENEFÍCIOS I",
        "value": 622
    }, {
        "label": "ANALISTA BANCO DE DADOS",
        "value": 223
    }, {
        "label": "ANALISTA CARGOS E SALARIOS",
        "value": 543
    }, {
        "label": "ANALISTA CARGOS E SALÁRIOS JR",
        "value": 555
    }, {
        "label": "ANALISTA CARGOS E SALÁRIOS PL",
        "value": 556
    }, {
        "label": "ANALISTA CARGOS E SALÁRIOS SR",
        "value": 557
    }, {
        "label": "ANALISTA CONTABIL",
        "value": 138
    }, {
        "label": "ANALISTA CONTABIL I",
        "value": 727
    }, {
        "label": "ANALISTA CONTABIL II",
        "value": 728
    }, {
        "label": "ANALISTA CONTABIL III",
        "value": 729
    }, {
        "label": "ANALISTA CONTABIL IV",
        "value": 730
    }, {
        "label": "ANALISTA CONTABIL V",
        "value": 731
    }, {
        "label": "ANALISTA CONTABIL VI",
        "value": 732
    }, {
        "label": "ANALISTA CONTEÚDO",
        "value": 847
    }, {
        "label": "Analista Conteúdo",
        "value": 846
    }, {
        "label": "ANALISTA DBM I",
        "value": 608
    }, {
        "label": "ANALISTA DBM II",
        "value": 609
    }, {
        "label": "ANALISTA DBM III",
        "value": 610
    }, {
        "label": "ANALISTA DBM IV",
        "value": 611
    }, {
        "label": "ANALISTA DBM V",
        "value": 612
    }, {
        "label": "ANALISTA DBM VI",
        "value": 613
    }, {
        "label": "Analista de câmbio ",
        "value": 867
    }, {
        "label": "Analista de cobrança",
        "value": 868
    }, {
        "label": "ANALISTA DE CUSTOS",
        "value": 219
    }, {
        "label": "ANALISTA DE DBM JR",
        "value": 540
    }, {
        "label": "ANALISTA DE HELP DESK   I",
        "value": 514
    }, {
        "label": "ANALISTA DE HELP DESK   V",
        "value": 513
    }, {
        "label": "ANALISTA DE HELP DESK  IV",
        "value": 148
    }, {
        "label": "ANALISTA DE MARKETING",
        "value": 537
    }, {
        "label": "Analista de negócios ",
        "value": 869
    }, {
        "label": "ANALISTA DE NOVAS TECNOLOGIAS",
        "value": 333
    }, {
        "label": "ANALISTA DE PESSOAL I",
        "value": 628
    }, {
        "label": "ANALISTA DE PESSOAL II",
        "value": 629
    }, {
        "label": "ANALISTA DE PESSOAL III",
        "value": 630
    }, {
        "label": "ANALISTA DE PESSOAL JR",
        "value": 216
    }, {
        "label": "ANALISTA DE PESSOAL PL",
        "value": 211
    }, {
        "label": "ANALISTA DE PESSOAL V",
        "value": 632
    }, {
        "label": "ANALISTA DE PESSOAL VI",
        "value": 633
    }, {
        "label": "ANALISTA DE PLENEJAMENTO E CONTROLE JR",
        "value": 837
    }, {
        "label": "ANALISTA DE PRODUTO",
        "value": 892
    }, {
        "label": "ANALISTA DE RECURSOS HUMANOS",
        "value": 891
    }, {
        "label": "ANALISTA E-COMMERCE",
        "value": 733
    }, {
        "label": "ANALISTA FATURAMENTO AÉREO",
        "value": 872
    }, {
        "label": "Analista Faturamento Aéreo",
        "value": 871
    }, {
        "label": "ANALISTA FINANCEIRO JR.",
        "value": 832
    }, {
        "label": "ANALISTA FINANCEIRO PL",
        "value": 843
    }, {
        "label": "Analista Financeiro Pl.",
        "value": 889
    }, {
        "label": "ANALISTA FINANCEIRO SR",
        "value": 806
    }, {
        "label": "ANALISTA FISCAL",
        "value": 201
    }, {
        "label": "ANALISTA HELP DESK  II",
        "value": 180
    }, {
        "label": "ANALISTA HELP DESK II",
        "value": 685
    }, {
        "label": "ANALISTA HELP DESK III",
        "value": 539
    }, {
        "label": "ANALISTA HELP DESK VI",
        "value": 686
    }, {
        "label": "ANALISTA NOVAS TECNOLOGIAS",
        "value": 718
    }, {
        "label": "ANALISTA ORCAMENTO",
        "value": 457
    }, {
        "label": "ANALISTA PESSOAL IV",
        "value": 631
    }, {
        "label": "ANALISTA PROJETO ONLINE",
        "value": 735
    }, {
        "label": "ANALISTA REC. HUMANOS SR.",
        "value": 525
    }, {
        "label": "ANALISTA RECR. E SELEÇÃO I",
        "value": 618
    }, {
        "label": "ANALISTA RECR. E SELEÇÃO II",
        "value": 619
    }, {
        "label": "ANALISTA RECR. E SELEÇÃO III",
        "value": 317
    }, {
        "label": "ANALISTA RECR. E SELEÇÃO IV",
        "value": 318
    }, {
        "label": "ANALISTA RECR. E SELEÇÃO V",
        "value": 620
    }, {
        "label": "ANALISTA RECR. E SELEÇÃO VI",
        "value": 621
    }, {
        "label": "ANALISTA REMUNERAÇÃO E BENEFÍCIOS I ",
        "value": 754
    }, {
        "label": "ANALISTA REMUNERAÇÃO E BENEFÍCIOS II",
        "value": 322
    }, {
        "label": "ANALISTA REMUNERAÇÃO E BENEFÍCIOS III",
        "value": 623
    }, {
        "label": "ANALISTA REMUNERAÇÃO E BENEFÍCIOS IV",
        "value": 324
    }, {
        "label": "ANALISTA REMUNERAÇÃO E BENEFÍCIOS V",
        "value": 624
    }, {
        "label": "ANALISTA REMUNERAÇÃO E BENEFÍCIOS VI",
        "value": 625
    }, {
        "label": "ANALISTA SISTEMA JR.",
        "value": 10
    }, {
        "label": "ANALISTA SISTEMA PL.",
        "value": 228
    }, {
        "label": "ANALISTA SISTEMA SR.",
        "value": 165
    }, {
        "label": "ANALISTA SISTEMAS PL.",
        "value": 699
    }, {
        "label": "ANALISTA SISTEMAS SR.",
        "value": 698
    }, {
        "label": "ANALISTA SUPORTE TECNICO JR",
        "value": 132
    }, {
        "label": "ANALISTA SUPORTE TECNICO SR",
        "value": 471
    }, {
        "label": "ANALISTA T & D I",
        "value": 818
    }, {
        "label": "ANALISTA T & D IV",
        "value": 804
    }, {
        "label": "ANALISTA TRAFEGO",
        "value": 736
    }, {
        "label": "ANALISTA TREINAMENTO DE PRODUTO",
        "value": 812
    }, {
        "label": "ANALISTA/ASSISTENTE",
        "value": 2
    }, {
        "label": "APOSENTADO",
        "value": 819
    }, {
        "label": "ASSESSOR DE IMPRENSA",
        "value": 485
    }, {
        "label": "ASSESSOR PRESIDENCIA",
        "value": 751
    }, {
        "label": "ASSIST. ADM .PESSOAL",
        "value": 385
    }, {
        "label": "ASSISTENDE DE VENDAS III",
        "value": 592
    }, {
        "label": "ASSISTENTE  ARTE",
        "value": 719
    }, {
        "label": "ASSISTENTE ADMINISTRATIVO",
        "value": 386
    }, {
        "label": "ASSISTENTE ADMINISTRATIVO III",
        "value": 484
    }, {
        "label": "ASSISTENTE ALMOXARIFADO",
        "value": 803
    }, {
        "label": "ASSISTENTE ATENDIMENTO CLIENTE",
        "value": 521
    }, {
        "label": "ASSISTENTE AUDITORIA",
        "value": 764
    }, {
        "label": "ASSISTENTE AUDITORIA - CAIXA",
        "value": 387
    }, {
        "label": "ASSISTENTE COMERCIAL",
        "value": 240
    }, {
        "label": "ASSISTENTE COMERCIAL  II",
        "value": 490
    }, {
        "label": "ASSISTENTE COMERCIAL I",
        "value": 14
    }, {
        "label": "ASSISTENTE COMERCIAL III",
        "value": 506
    }, {
        "label": "ASSISTENTE COMERCIAL VI",
        "value": 480
    }, {
        "label": "ASSISTENTE COML. INTERNACIONAL",
        "value": 500
    }, {
        "label": "ASSISTENTE COMPRAS",
        "value": 769
    }, {
        "label": "ASSISTENTE COMPRAS E SERVICOS",
        "value": 494
    }, {
        "label": "ASSISTENTE COMPUTACAO GRAFICA",
        "value": 533
    }, {
        "label": "ASSISTENTE CONTAS A PAGAR I",
        "value": 370
    }, {
        "label": "ASSISTENTE CONTAS A PAGAR II",
        "value": 661
    }, {
        "label": "ASSISTENTE CONTAS A PAGAR III",
        "value": 662
    }, {
        "label": "ASSISTENTE CONTAS A PAGAR IV",
        "value": 663
    }, {
        "label": "ASSISTENTE CONTAS A PAGAR V",
        "value": 664
    }, {
        "label": "ASSISTENTE CONTAS A PAGAR VI",
        "value": 665
    }, {
        "label": "ASSISTENTE CONTAS A RECEBER I",
        "value": 378
    }, {
        "label": "ASSISTENTE CONTAS A RECEBER II",
        "value": 666
    }, {
        "label": "ASSISTENTE CONTAS A RECEBER III",
        "value": 667
    }, {
        "label": "ASSISTENTE CONTAS A RECEBER IV",
        "value": 668
    }, {
        "label": "ASSISTENTE CONTAS A RECEBER V",
        "value": 669
    }, {
        "label": "ASSISTENTE CONTAS A RECEBER VI",
        "value": 670
    }, {
        "label": "ASSISTENTE DE ARTE",
        "value": 634
    }, {
        "label": "ASSISTENTE DE CUSTOS",
        "value": 391
    }, {
        "label": "ASSISTENTE DE PRODUTO",
        "value": 534
    }, {
        "label": "ASSISTENTE DE PRODUTO II",
        "value": 547
    }, {
        "label": "ASSISTENTE DE PRODUTO III",
        "value": 582
    }, {
        "label": "ASSISTENTE DE PRODUTO IV",
        "value": 583
    }, {
        "label": "ASSISTENTE DE PRODUTO V",
        "value": 584
    }, {
        "label": "ASSISTENTE DE PRODUTO VI",
        "value": 585
    }, {
        "label": "ASSISTENTE DE RECUSRSOS HUMANOS ",
        "value": 884
    }, {
        "label": "ASSISTENTE DE VENDAS",
        "value": 550
    }, {
        "label": "ASSISTENTE DE VENDAS  I",
        "value": 389
    }, {
        "label": "ASSISTENTE DE VENDAS  II",
        "value": 526
    }, {
        "label": "ASSISTENTE FINANCEIRO",
        "value": 809
    }, {
        "label": "ASSISTENTE FINANCEIRO I",
        "value": 328
    }, {
        "label": "ASSISTENTE FINANCEIRO II",
        "value": 329
    }, {
        "label": "ASSISTENTE FINANCEIRO III",
        "value": 626
    }, {
        "label": "ASSISTENTE FINANCEIRO IV",
        "value": 331
    }, {
        "label": "ASSISTENTE FINANCEIRO V",
        "value": 627
    }, {
        "label": "ASSISTENTE INTERNACIONAL I",
        "value": 388
    }, {
        "label": "ASSISTENTE JURIDICO",
        "value": 531
    }, {
        "label": "ASSISTENTE JURIDICO II",
        "value": 761
    }, {
        "label": "Assistente Merchandising Visual",
        "value": 875
    }, {
        "label": "ASSISTENTE RECURSOS HUMANOS I",
        "value": 687
    }, {
        "label": "ASSISTENTE RECURSOS HUMANOS II",
        "value": 688
    }, {
        "label": "ASSISTENTE RECURSOS HUMANOS III",
        "value": 689
    }, {
        "label": "ASSISTENTE RECURSOS HUMANOS IV",
        "value": 690
    }, {
        "label": "ASSISTENTE RECURSOS HUMANOS V",
        "value": 691
    }, {
        "label": "ASSISTENTE RECURSOS HUMANOS VI",
        "value": 692
    }, {
        "label": "ASSISTENTE RELACAO COM CLIENTE",
        "value": 501
    }, {
        "label": "ASSISTENTE RELACOES INTERNA",
        "value": 458
    }, {
        "label": "ASSISTENTE VENDAS INTERNACIONAL",
        "value": 466
    }, {
        "label": "ASSIST.OPER.INTERNACIONAL I",
        "value": 545
    }, {
        "label": "ASSIST.OPER.INTERNACIONAL II",
        "value": 465
    }, {
        "label": "ASSIST.OPER.INTERNACIONAL III",
        "value": 504
    }, {
        "label": "ASSIST.OPER.INTERNACIONAL IV",
        "value": 477
    }, {
        "label": "ASSIST.OPER.INTERNACIONAL V",
        "value": 476
    }, {
        "label": "ASSIST.OPER.NACIONAL  II",
        "value": 390
    }, {
        "label": "ATENDENTE",
        "value": 392
    }, {
        "label": "AUDITOR",
        "value": 763
    }, {
        "label": "AUDITOR CHEFE",
        "value": 765
    }, {
        "label": "AUDITOR DE CAIXA",
        "value": 200
    }, {
        "label": "AUDITORIA",
        "value": 760
    }, {
        "label": "Autônomo",
        "value": 888
    }, {
        "label": "AUX. ATENDIMENTO LOJAS I",
        "value": 840
    }, {
        "label": "AUX. ATENDIMENTO LOJAS III",
        "value": 841
    }, {
        "label": "AUX.ATENDIMENTO CLIENTE   I",
        "value": 527
    }, {
        "label": "AUX.ATENDIMENTO CLIENTE  II",
        "value": 520
    }, {
        "label": "AUX.ATENDIMENTO CLIENTE  IV",
        "value": 529
    }, {
        "label": "AUX.ATENDIMENTO CLIENTE III",
        "value": 528
    }, {
        "label": "AUX.ATENDIMENTO CLIENTE V",
        "value": 591
    }, {
        "label": "AUX.ATENDIMENTO CLIENTE VI",
        "value": 652
    }, {
        "label": "AUXILIAR",
        "value": 1
    }, {
        "label": "AUXILIAR ADM. PESSOAL  I",
        "value": 517
    }, {
        "label": "AUXILIAR ADM. PESSOAL  II",
        "value": 395
    }, {
        "label": "AUXILIAR ADMINISTRATIVO I",
        "value": 394
    }, {
        "label": "AUXILIAR ADMINISTRATIVO II",
        "value": 463
    }, {
        "label": "AUXILIAR ADMINISTRATIVO III",
        "value": 253
    }, {
        "label": "AUXILIAR ADMINISTRATIVO IV",
        "value": 569
    }, {
        "label": "AUXILIAR ADMINISTRATIVO V",
        "value": 464
    }, {
        "label": "AUXILIAR ADMINISTRATIVO VI",
        "value": 255
    }, {
        "label": "AUXILIAR ALMOXARIFADO",
        "value": 396
    }, {
        "label": "AUXILIAR ALMOXARIFADO I",
        "value": 748
    }, {
        "label": "AUXILIAR ALMOXARIFADO III",
        "value": 749
    }, {
        "label": "AUXILIAR ASSESSOR DE IMPRENSA",
        "value": 496
    }, {
        "label": "AUXILIAR AUDITORIA CAIXA",
        "value": 420
    }, {
        "label": "AUXILIAR CAIXA",
        "value": 406
    }, {
        "label": "AUXILIAR COMERCIAL",
        "value": 535
    }, {
        "label": "AUXILIAR COMERCIAL I",
        "value": 573
    }, {
        "label": "AUXILIAR COMERCIAL II",
        "value": 264
    }, {
        "label": "AUXILIAR COMERCIAL III",
        "value": 265
    }, {
        "label": "AUXILIAR COMERCIAL IV",
        "value": 574
    }, {
        "label": "AUXILIAR COMERCIAL V",
        "value": 575
    }, {
        "label": "AUXILIAR COMERCIAL VI",
        "value": 576
    }, {
        "label": "AUXILIAR COMPRAS",
        "value": 808
    }, {
        "label": "AUXILIAR COMPUTACAO GRAFICA",
        "value": 474
    }, {
        "label": "AUXILIAR CONTABILIDADE I",
        "value": 90
    }, {
        "label": "AUXILIAR CONTABILIDADE II",
        "value": 87
    }, {
        "label": "AUXILIAR CONTABILIDADE III",
        "value": 393
    }, {
        "label": "AUXILIAR CONTABILIDADE IV",
        "value": 511
    }, {
        "label": "AUXILIAR CONTABILIDADE V",
        "value": 397
    }, {
        "label": "AUXILIAR CONTABILIDADE VI",
        "value": 503
    }, {
        "label": "AUXILIAR CONTAS A RECEBER I",
        "value": 258
    }, {
        "label": "AUXILIAR CONTAS A RECEBER II",
        "value": 571
    }, {
        "label": "AUXILIAR CONTAS A RECEBER III",
        "value": 260
    }, {
        "label": "AUXILIAR C.P.D.",
        "value": 407
    }, {
        "label": "AUXILIAR CRÉDITO COBRANÇA I",
        "value": 600
    }, {
        "label": "AUXILIAR CRÉDITO COBRANÇA II",
        "value": 601
    }, {
        "label": "AUXILIAR CRÉDITO COBRANÇA III",
        "value": 602
    }, {
        "label": "AUXILIAR CRÉDITO COBRANÇA IV",
        "value": 603
    }, {
        "label": "AUXILIAR CRÉDITO COBRANÇA V",
        "value": 604
    }, {
        "label": "AUXILIAR CRÉDITO COBRANÇA VI",
        "value": 605
    }, {
        "label": "AUXILIAR DE CONTAS A PAGAR",
        "value": 171
    }, {
        "label": "AUXILIAR DE CONTAS A PAGAR II",
        "value": 548
    }, {
        "label": "AUXILIAR DE CONTAS A PAGAR III",
        "value": 222
    }, {
        "label": "AUXILIAR DE CUSTOS I",
        "value": 398
    }, {
        "label": "AUXILIAR DE CUSTOS II",
        "value": 113
    }, {
        "label": "AUXILIAR DE CUSTOS III",
        "value": 566
    }, {
        "label": "AUXILIAR DE CUSTOS IV",
        "value": 516
    }, {
        "label": "AUXILIAR DE CUSTOS V",
        "value": 567
    }, {
        "label": "AUXILIAR DE CUSTOS VI",
        "value": 568
    }, {
        "label": "AUXILIAR DE EDUCAÇÃO CORPORATIVA",
        "value": 834
    }, {
        "label": "AUXILIAR DE EMBARQUE",
        "value": 433
    }, {
        "label": "AUXILIAR DE ESCRITORIO I",
        "value": 26
    }, {
        "label": "AUXILIAR DE ESCRITORIO II",
        "value": 459
    }, {
        "label": "AUXILIAR DE ESCRITORIO III",
        "value": 460
    }, {
        "label": "AUXILIAR DE ESCRITORIO IV",
        "value": 461
    }, {
        "label": "AUXILIAR DE ESCRITORIO V",
        "value": 462
    }, {
        "label": "AUXILIAR DE ESCRITORIO VI",
        "value": 478
    }, {
        "label": "AUXILIAR DE EXCURSAO II",
        "value": 399
    }, {
        "label": "AUXILIAR DE EXCURSAO III",
        "value": 524
    }, {
        "label": "AUXILIAR DE EXCURSAO IV",
        "value": 468
    }, {
        "label": "AUXILIAR DE EXCURSAO V",
        "value": 502
    }, {
        "label": "AUXILIAR DE EXCURSAO VI",
        "value": 467
    }, {
        "label": "AUXILIAR DE RESERVAS  I",
        "value": 481
    }, {
        "label": "AUXILIAR DE RESERVAS  II",
        "value": 505
    }, {
        "label": "AUXILIAR DE RESERVAS III",
        "value": 479
    }, {
        "label": "AUXILIAR DE RESERVAS IV",
        "value": 483
    }, {
        "label": "AUXILIAR DE RESERVAS V",
        "value": 402
    }, {
        "label": "AUXILIAR DE SUPORTE SISTEMAS",
        "value": 519
    }, {
        "label": "AUXILIAR E-COMMERCE",
        "value": 822
    }, {
        "label": "AUXILIAR FATURAMENTO AEREO",
        "value": 498
    }, {
        "label": "AUXILIAR FATURAMENTO AEREO II",
        "value": 674
    }, {
        "label": "AUXILIAR FATURAMENTO AEREO III",
        "value": 675
    }, {
        "label": "AUXILIAR FATURAMENTO AEREO IV",
        "value": 676
    }, {
        "label": "AUXILIAR FATURAMENTO AEREO V",
        "value": 677
    }, {
        "label": "AUXILIAR FATURAMENTO AEREO VI",
        "value": 678
    }, {
        "label": "AUXILIAR FATURAMENTO INTERNACIONAL I",
        "value": 777
    }, {
        "label": "AUXILIAR FATURAMENTO INTERNACIONAL II",
        "value": 778
    }, {
        "label": "AUXILIAR FATURAMENTO INTERNACIONAL III",
        "value": 779
    }, {
        "label": "AUXILIAR FATURAMENTO INTERNACIONAL IV",
        "value": 780
    }, {
        "label": "AUXILIAR FATURAMENTO INTERNACIONAL V",
        "value": 781
    }, {
        "label": "AUXILIAR FATURAMENTO INTERNACIONAL VI",
        "value": 782
    }, {
        "label": "AUXILIAR FINANCEIRO I",
        "value": 257
    }, {
        "label": "AUXILIAR FINANCEIRO II",
        "value": 204
    }, {
        "label": "AUXILIAR FINANCEIRO III",
        "value": 202
    }, {
        "label": "AUXILIAR FINANCEIRO IV",
        "value": 475
    }, {
        "label": "AUXILIAR FINANCEIRO V",
        "value": 404
    }, {
        "label": "AUXILIAR FINANCEIRO VI",
        "value": 469
    }, {
        "label": "AUXILIAR INTERNACIONAL",
        "value": 405
    }, {
        "label": "AUXILIAR MANUTENÇÃO I",
        "value": 679
    }, {
        "label": "AUXILIAR MANUTENÇÃO II",
        "value": 680
    }, {
        "label": "AUXILIAR MANUTENÇÃO III",
        "value": 681
    }, {
        "label": "AUXILIAR MANUTENÇÃO IV",
        "value": 682
    }, {
        "label": "AUXILIAR MANUTENÇÃO V",
        "value": 683
    }, {
        "label": "AUXILIAR MANUTENÇÃO VI",
        "value": 684
    }, {
        "label": "AUXILIAR MANUT.PREDIAL",
        "value": 400
    }, {
        "label": "AUXILIAR MARKETING I",
        "value": 646
    }, {
        "label": "AUXILIAR MARKETING II",
        "value": 647
    }, {
        "label": "AUXILIAR MARKETING III",
        "value": 648
    }, {
        "label": "AUXILIAR MARKETING IV",
        "value": 649
    }, {
        "label": "AUXILIAR MARKETING V",
        "value": 650
    }, {
        "label": "AUXILIAR MARKETING VI",
        "value": 651
    }, {
        "label": "AUXILIAR OPERACIONAL DE HOTELARIA IV",
        "value": 839
    }, {
        "label": "AUXILIAR OPERACIONAL I",
        "value": 34
    }, {
        "label": "AUXILIAR OPERACIONAL II",
        "value": 85
    }, {
        "label": "AUXILIAR OPERACIONAL III",
        "value": 487
    }, {
        "label": "AUXILIAR OPERACIONAL INTERNACIONAL I",
        "value": 645
    }, {
        "label": "AUXILIAR OPERACIONAL INTERNACIONAL II",
        "value": 758
    }, {
        "label": "AUXILIAR OPERACIONAL IV",
        "value": 129
    }, {
        "label": "AUXILIAR OPERACIONAL V",
        "value": 559
    }, {
        "label": "AUXILIAR OPERACIONAL VI",
        "value": 722
    }, {
        "label": "AUXILIAR ORÇAMENTO",
        "value": 456
    }, {
        "label": "AUXILIAR PATRIMONIO",
        "value": 401
    }, {
        "label": "AUXILIAR PROCESSAMENTO DADOS I",
        "value": 753
    }, {
        "label": "AUXILIAR PRODUTO II",
        "value": 747
    }, {
        "label": "AUXILIAR PRODUTO III",
        "value": 813
    }, {
        "label": "AUXILIAR SERVIÇOS GERAIS",
        "value": 403
    }, {
        "label": "BABÁ",
        "value": 848
    }, {
        "label": "CAIXA I",
        "value": 37
    }, {
        "label": "CAIXA II",
        "value": 44
    }, {
        "label": "CAIXA III",
        "value": 45
    }, {
        "label": "CAIXA IV",
        "value": 413
    }, {
        "label": "CAIXA V",
        "value": 419
    }, {
        "label": "CAIXA VI",
        "value": 124
    }, {
        "label": "CONCILIADOR FINANCEIRO I",
        "value": 755
    }, {
        "label": "CONSULTOR DE PROJETOS TURISTICOS",
        "value": 276
    }, {
        "label": "CONSULTOR RECURSOS HUMANOS",
        "value": 790
    }, {
        "label": "CONSULTOR TREINAMENTO PRODUTOS",
        "value": 768
    }, {
        "label": "CONSULTOR-ASSESSOR",
        "value": 4
    }, {
        "label": "CONTADOR",
        "value": 408
    }, {
        "label": "CONTINUO",
        "value": 39
    }, {
        "label": "CONTROL.DE PASSAGENS",
        "value": 409
    }, {
        "label": "CONTROLLER",
        "value": 232
    }, {
        "label": "CONTROLLER CORPORATIVO",
        "value": 495
    }, {
        "label": "COORD.DE AUD.- CAIXA",
        "value": 410
    }, {
        "label": "COORD.DE EXCURSAO",
        "value": 411
    }, {
        "label": "COORDENADOR ATENDIMENTO CLIENTE I",
        "value": 746
    }, {
        "label": "COORDENADOR DE REPRESENTAÇÃO",
        "value": 833
    }, {
        "label": "COORDENADOR SAC REEMBOLSO",
        "value": 829
    }, {
        "label": "COORD.FATURAMENTO AEREO",
        "value": 497
    }, {
        "label": "COORD.FINANCEIRO",
        "value": 412
    }, {
        "label": "COORD.OPERACOES INTERNACIONAIS",
        "value": 432
    }, {
        "label": "COORD.RECURSOS HUMANOS",
        "value": 523
    }, {
        "label": "DENTISTA",
        "value": 877
    }, {
        "label": "DESEMBARGADOR",
        "value": 821
    }, {
        "label": "DESEMBARGADOR",
        "value": 820
    }, {
        "label": "Designer Instrucional",
        "value": 844
    }, {
        "label": "DIGITADOR",
        "value": 672
    }, {
        "label": "DIREÇÃO-SUPERINTENDENCIA",
        "value": 6
    }, {
        "label": "DIRETOR ADJUNTO",
        "value": 878
    }, {
        "label": "DIRETOR COMERCIAL",
        "value": 224
    }, {
        "label": "DIRETOR COMERCIAL INTERNACIONAL",
        "value": 659
    }, {
        "label": "DIRETOR DE MARKETING",
        "value": 572
    }, {
        "label": "DIRETOR DE RECURSOS HUMANOS",
        "value": 261
    }, {
        "label": "DIRETOR EVENTOS",
        "value": 599
    }, {
        "label": "DIRETOR FINANCEIRO",
        "value": 50
    }, {
        "label": "DIRETOR GERAL",
        "value": 53
    }, {
        "label": "DIRETOR INFORMATICA",
        "value": 231
    }, {
        "label": "Diretor Jurídico",
        "value": 876
    }, {
        "label": "DIRETOR OPERAÇÕES",
        "value": 766
    }, {
        "label": "DIRETOR RECURSOS HUMANOS",
        "value": 705
    }, {
        "label": "DIRETOR SUPERINTENDENTE",
        "value": 384
    }, {
        "label": "DIRETOR VENDAS",
        "value": 697
    }, {
        "label": "DIRETOR VENDAS INTERNACIONAL",
        "value": 614
    }, {
        "label": "Dona de Casa",
        "value": 885
    }, {
        "label": "EMISSOR DE PASSAGENS I",
        "value": 57
    }, {
        "label": "EMISSOR DE PASSAGENS II",
        "value": 491
    }, {
        "label": "EMISSOR DE PASSAGENS III",
        "value": 158
    }, {
        "label": "EMISSOR DE PASSAGENS IV",
        "value": 421
    }, {
        "label": "EMISSOR PASSAGENS INTERNACIONAL I",
        "value": 771
    }, {
        "label": "EMISSOR PASSAGENS INTERNACIONAL II",
        "value": 772
    }, {
        "label": "EMISSOR PASSAGENS INTERNACIONAL III",
        "value": 773
    }, {
        "label": "EMISSOR PASSAGENS INTERNACIONAL IV",
        "value": 774
    }, {
        "label": "EMISSOR PASSAGENS INTERNACIONAL V",
        "value": 775
    }, {
        "label": "EMISSOR PASSAGENS INTERNACIONAL VI",
        "value": 776
    }, {
        "label": "ENCARREGADO APOIO ADMINISTRATIVO",
        "value": 742
    }, {
        "label": "ENCARREGADO AUDITORIA",
        "value": 720
    }, {
        "label": "ENCARREGADO CONTAS A PAGAR",
        "value": 210
    }, {
        "label": "ENCARREGADO CONTAS A RECEBER",
        "value": 377
    }, {
        "label": "ENCARREGADO CONTROLE E VAL. CAIXAS",
        "value": 811
    }, {
        "label": "ENCARREGADO DE AUDITORIA",
        "value": 376
    }, {
        "label": "ENCARREGADO FINANCEIRO I",
        "value": 482
    }, {
        "label": "ENCARREGADO FINANCEIRO II",
        "value": 60
    }, {
        "label": "ENCARREGADO INTERNACIONAL",
        "value": 426
    }, {
        "label": "ENCARREGADO OPERACIONAL",
        "value": 423
    }, {
        "label": "ENCARREGADO OPERACOES C.P.D.",
        "value": 424
    }, {
        "label": "ENCARREGADO RESERVAS",
        "value": 422
    }, {
        "label": "ENCARREGADO SERVICOS GERAIS",
        "value": 425
    }, {
        "label": "ENCARREGADO TESOURARIA",
        "value": 739
    }, {
        "label": "ENGENHEIRO",
        "value": 801
    }, {
        "label": "ESTAGIÁRIO",
        "value": 220
    }, {
        "label": "ESTATISTICO",
        "value": 542
    }, {
        "label": "Estudante",
        "value": 886
    }, {
        "label": "GARCOM",
        "value": 470
    }, {
        "label": "GERENCIA",
        "value": 5
    }, {
        "label": "GERENTE ADM PESSOAL",
        "value": 794
    }, {
        "label": "GERENTE ADM.FINANCEIRO",
        "value": 415
    }, {
        "label": "GERENTE ADMINISTRATIVO",
        "value": 414
    }, {
        "label": "GERENTE ATENDIMENTO CLIENTE",
        "value": 745
    }, {
        "label": "GERENTE COMERCIAL I",
        "value": 137
    }, {
        "label": "GERENTE COMERCIAL NACIONAL",
        "value": 416
    }, {
        "label": "GERENTE COMERCIO ELETRONICO",
        "value": 814
    }, {
        "label": "GERENTE COM.INTERNACIONAL",
        "value": 427
    }, {
        "label": "GERENTE COMPRAS",
        "value": 767
    }, {
        "label": "GERENTE COMPRAS E SERVICOS",
        "value": 493
    }, {
        "label": "GERENTE COMPRAS SERV. NACIONAL",
        "value": 492
    }, {
        "label": "GERENTE CREDITO E COBRANÇA",
        "value": 797
    }, {
        "label": "GERENTE DE FILIAL",
        "value": 428
    }, {
        "label": "GERENTE DE PROC. DE DADOS",
        "value": 429
    }, {
        "label": "GERENTE DE PRODUTO",
        "value": 488
    }, {
        "label": "GERENTE DE PRODUTO  II",
        "value": 515
    }, {
        "label": "GERENTE DE PRODUTO I",
        "value": 606
    }, {
        "label": "GERENTE DE PRODUTO III",
        "value": 615
    }, {
        "label": "GERENTE DE PRODUTO IV",
        "value": 617
    }, {
        "label": "GERENTE DE PRODUTO V",
        "value": 616
    }, {
        "label": "GERENTE DE PROMOCAO",
        "value": 431
    }, {
        "label": "GERENTE DE SUPORTE TECNICO",
        "value": 313
    }, {
        "label": "GERENTE DE VENDAS",
        "value": 551
    }, {
        "label": "GERENTE DE VENDAS   I",
        "value": 418
    }, {
        "label": "GERENTE DE VENDAS III",
        "value": 507
    }, {
        "label": "GERENTE DE VENDAS V",
        "value": 508
    }, {
        "label": "GERENTE DEP.CONTR.QUALIDADE",
        "value": 473
    }, {
        "label": "GERENTE DESENVOLVIMENTO",
        "value": 229
    }, {
        "label": "GERENTE DESENVOLVIMENTO ORGANIZACIONAL",
        "value": 796
    }, {
        "label": "GERENTE E-BUSINESS",
        "value": 723
    }, {
        "label": "GERENTE EMISSÃO INTERNACIONAL",
        "value": 770
    }, {
        "label": "GERENTE FATURAMENTO AEREO",
        "value": 150
    }, {
        "label": "GERENTE FINANCEIRO",
        "value": 242
    }, {
        "label": "GERENTE GERAL",
        "value": 836
    }, {
        "label": "GERENTE MARKETING",
        "value": 673
    }, {
        "label": "GERENTE MARKETING DE RELACIONAMENTO",
        "value": 552
    }, {
        "label": "GERENTE OPER. INTERNACIONAL",
        "value": 509
    }, {
        "label": "GERENTE OPERAÇÃO NACIONAL",
        "value": 756
    }, {
        "label": "GERENTE OPERACIONAL",
        "value": 417
    }, {
        "label": "Gerente Planejamento de Vendas",
        "value": 879
    }, {
        "label": "GERENTE PRODUTO I",
        "value": 712
    }, {
        "label": "GERENTE PRODUTO III",
        "value": 714
    }, {
        "label": "GERENTE PRODUTO IV",
        "value": 716
    }, {
        "label": "GERENTE PRODUTO V",
        "value": 715
    }, {
        "label": "GERENTE QUALIDADE",
        "value": 743
    }, {
        "label": "GERENTE RECURSOS HUMANOS",
        "value": 430
    }, {
        "label": "GERENTE RODOVIARIO",
        "value": 447
    }, {
        "label": "Gerente Sr de Vendas",
        "value": 893
    }, {
        "label": "GERENTE SUPORTE TECNICO",
        "value": 717
    }, {
        "label": "GERENTE VENDAS INTERNACIONAL",
        "value": 581
    }, {
        "label": "GERENTE VENDAS REGIONAL",
        "value": 660
    }, {
        "label": "GUIA DE TURISMO",
        "value": 436
    }, {
        "label": "GUIA DE TURISMO INTERNACIONAL",
        "value": 445
    }, {
        "label": "Guias de Turismo - Autônomos",
        "value": 721
    }, {
        "label": "INSPETOR DE SEGURANÇA",
        "value": 894
    }, {
        "label": "Manobrista",
        "value": 863
    }, {
        "label": "Mecânico",
        "value": 864
    }, {
        "label": "Médico",
        "value": 845
    }, {
        "label": "Militar",
        "value": 883
    }, {
        "label": "MOTORISTA",
        "value": 434
    }, {
        "label": "OPERADOR COMPUTACAO GRAFICA",
        "value": 435
    }, {
        "label": "OPERADOR COMPUTADOR JR",
        "value": 437
    }, {
        "label": "OPERADOR COMPUTADOR PL",
        "value": 438
    }, {
        "label": "OPERADOR COMPUTADOR SR",
        "value": 439
    }, {
        "label": "OPERADOR DE TELEX III",
        "value": 440
    }, {
        "label": "Operador I",
        "value": 870
    }, {
        "label": "OPERADOR TELEX II",
        "value": 441
    }, {
        "label": "Outros",
        "value": 887
    }, {
        "label": "Pensionista",
        "value": 831
    }, {
        "label": "PESQUISADOR MERCADO",
        "value": 472
    }, {
        "label": "Policial",
        "value": 880
    }, {
        "label": "PRENDAS",
        "value": 881
    }, {
        "label": "PRESIDENTE",
        "value": 740
    }, {
        "label": "PRESIDENTE - VICE-PRESIDENTE",
        "value": 7
    }, {
        "label": "PRESIDENTE CONSELHO CONSULTIVO",
        "value": 825
    }, {
        "label": "PRESIDENTE CVC OPERADORA",
        "value": 828
    }, {
        "label": "PRESIDENTE DO CONSELHO DE ADMINISTRAÇÃO",
        "value": 823
    }, {
        "label": "PRESIDENTE HOLDING",
        "value": 827
    }, {
        "label": "PROGRAMADOR COMPUTADOR JR",
        "value": 442
    }, {
        "label": "PROGRAMADOR COMPUTADOR PL",
        "value": 443
    }, {
        "label": "PROGRAMADOR COMPUTADOR SR",
        "value": 444
    }, {
        "label": "PROGRAMADOR JR",
        "value": 792
    }, {
        "label": "PROJETISTA DE SITE",
        "value": 530
    }, {
        "label": "PROJETISTA DE SITE I",
        "value": 607
    }, {
        "label": "PROJETISTA DE SITE II",
        "value": 561
    }, {
        "label": "PROJETISTA DE SITE III",
        "value": 562
    }, {
        "label": "PROJETISTA DE SITE IV",
        "value": 563
    }, {
        "label": "PROJETISTA DE SITE V",
        "value": 564
    }, {
        "label": "PROJETISTA DE SITE VI",
        "value": 565
    }, {
        "label": "PROJETISTA SITE I",
        "value": 713
    }, {
        "label": "PROJETISTA SITE II",
        "value": 700
    }, {
        "label": "PROJETISTA SITE III",
        "value": 701
    }, {
        "label": "PROJETISTA SITE IV",
        "value": 702
    }, {
        "label": "PROJETISTA SITE V",
        "value": 703
    }, {
        "label": "PROJETISTA SITE VI",
        "value": 704
    }, {
        "label": "PROMOTOR DE VENDAS",
        "value": 586
    }, {
        "label": "PROMOTOR DE VENDAS I",
        "value": 553
    }, {
        "label": "PROMOTOR DE VENDAS II",
        "value": 554
    }, {
        "label": "PROPRIETARIO - SOCIO",
        "value": 8
    }, {
        "label": "RECEPCIONISTA",
        "value": 446
    }, {
        "label": "REDATOR",
        "value": 802
    }, {
        "label": "SECRETARIA COMPRAS E SERVICOS",
        "value": 448
    }, {
        "label": "SECRETARIA JUNIOR",
        "value": 532
    }, {
        "label": "SECRETÁRIA PRESIDENCIA",
        "value": 750
    }, {
        "label": "SECRETARIA SENIOR",
        "value": 671
    }, {
        "label": "SEGURANÇA",
        "value": 882
    }, {
        "label": "SEGURANÇA DE REDES",
        "value": 230
    }, {
        "label": "SUB-CONTADOR",
        "value": 449
    }, {
        "label": "Sub-Gerente Controle Aéreo",
        "value": 890
    }, {
        "label": "SUPERV. COMPRAS SERV. NACIONAL",
        "value": 518
    }, {
        "label": "SUPERV. FATURAMENTO AÉREO",
        "value": 241
    }, {
        "label": "SUPERVISÃO-COORDENAÇÃO",
        "value": 3
    }, {
        "label": "SUPERVISOR  BRINDES & ACES E UNIFORMES",
        "value": 544
    }, {
        "label": "SUPERVISOR ADM DE PESSOAL",
        "value": 58
    }, {
        "label": "SUPERVISOR ADMINISTRATIVO",
        "value": 486
    }, {
        "label": "SUPERVISOR APOIO ADMINISTRATIVO",
        "value": 805
    }, {
        "label": "SUPERVISOR ATEND. C/CLIENTES II",
        "value": 590
    }, {
        "label": "SUPERVISOR ATEND. C/CLIENTES III",
        "value": 510
    }, {
        "label": "SUPERVISOR ATEND. C/CLIENTES IV",
        "value": 587
    }, {
        "label": "SUPERVISOR ATEND. C/CLIENTES V",
        "value": 588
    }, {
        "label": "SUPERVISOR ATEND. C/CLIENTES VI",
        "value": 589
    }, {
        "label": "SUPERVISOR ATEND. INTERNACIONAL",
        "value": 789
    }, {
        "label": "SUPERVISOR AUDITORIA",
        "value": 762
    }, {
        "label": "SUPERVISOR AUDITORIA DE CAIXA",
        "value": 314
    }, {
        "label": "SUPERVISOR COMERCIAL",
        "value": 450
    }, {
        "label": "SUPERVISOR COMERCIAL III",
        "value": 271
    }, {
        "label": "SUPERVISOR COMERCIAL IV",
        "value": 578
    }, {
        "label": "SUPERVISOR COMERCIAL V",
        "value": 579
    }, {
        "label": "SUPERVISOR COMERCIAL VI",
        "value": 580
    }, {
        "label": "SUPERVISOR COMPRAS",
        "value": 795
    }, {
        "label": "SUPERVISOR CONTABIL",
        "value": 195
    }, {
        "label": "SUPERVISOR CONTABIL FISCAL",
        "value": 361
    }, {
        "label": "SUPERVISOR CONTAS A RECEBER",
        "value": 327
    }, {
        "label": "SUPERVISOR CONTEUDO ONLINE",
        "value": 737
    }, {
        "label": "SUPERVISOR CONTROLE E VAL. CAIXAS",
        "value": 807
    }, {
        "label": "SUPERVISOR DBM",
        "value": 636
    }, {
        "label": "SUPERVISOR DE CONTAS A PAGAR",
        "value": 156
    }, {
        "label": "SUPERVISOR DE CUSTOS",
        "value": 64
    }, {
        "label": "SUPERVISOR DE FILIAL",
        "value": 451
    }, {
        "label": "SUPERVISOR DE INFORMATICA",
        "value": 499
    }, {
        "label": "SUPERVISOR DE PLANEJAMENTO E CONTROLE",
        "value": 830
    }, {
        "label": "SUPERVISOR DE PLANEJAMENTO E CONTROLE",
        "value": 838
    }, {
        "label": "SUPERVISOR DE PRODUTO I",
        "value": 593
    }, {
        "label": "SUPERVISOR DE PRODUTO II",
        "value": 594
    }, {
        "label": "SUPERVISOR DE PRODUTO III",
        "value": 595
    }, {
        "label": "SUPERVISOR DE PRODUTO IV",
        "value": 596
    }, {
        "label": "SUPERVISOR DE PRODUTO V",
        "value": 597
    }, {
        "label": "SUPERVISOR DE PRODUTO VI",
        "value": 598
    }, {
        "label": "SUPERVISOR DE TELEFONIA",
        "value": 800
    }, {
        "label": "SUPERVISOR DE VENDAS",
        "value": 538
    }, {
        "label": "SUPERVISOR DE VENDAS IV",
        "value": 560
    }, {
        "label": "SUPERVISOR DE VENDAS V",
        "value": 558
    }, {
        "label": "SUPERVISOR DESENVOLVIMENTO",
        "value": 799
    }, {
        "label": "SUPERVISOR EMISSÃO INTERNACIONAL I",
        "value": 783
    }, {
        "label": "SUPERVISOR EMISSÃO INTERNACIONAL II",
        "value": 784
    }, {
        "label": "SUPERVISOR EMISSÃO INTERNACIONAL III",
        "value": 785
    }, {
        "label": "SUPERVISOR EMISSÃO INTERNACIONAL IV",
        "value": 786
    }, {
        "label": "SUPERVISOR EMISSÃO INTERNACIONAL V",
        "value": 787
    }, {
        "label": "SUPERVISOR EMISSÃO INTERNACIONAL VI",
        "value": 788
    }, {
        "label": "SUPERVISOR EVENTOS",
        "value": 816
    }, {
        "label": "SUPERVISOR FATURAMENTO AÉREO I",
        "value": 724
    }, {
        "label": "SUPERVISOR FATURAMENTO AÉREO II",
        "value": 725
    }, {
        "label": "SUPERVISOR FATURAMENTO AÉREO III",
        "value": 726
    }, {
        "label": "SUPERVISOR FINANCEIRO",
        "value": 791
    }, {
        "label": "SUPERVISOR INTERNACIONAL",
        "value": 453
    }, {
        "label": "SUPERVISOR MARKETING DE RELACIONAMENTO",
        "value": 541
    }, {
        "label": "SUPERVISOR NEGÓCIOS CORPORATIVOS",
        "value": 734
    }, {
        "label": "SUPERVISOR NOVOS NEGOCIOS",
        "value": 738
    }, {
        "label": "SUPERVISOR OPER. INTERNACIONAL",
        "value": 454
    }, {
        "label": "SUPERVISOR OPER. INTERNACIONAL I",
        "value": 653
    }, {
        "label": "SUPERVISOR OPER. INTERNACIONAL II",
        "value": 654
    }, {
        "label": "SUPERVISOR OPER. INTERNACIONAL III",
        "value": 655
    }, {
        "label": "SUPERVISOR OPER. INTERNACIONAL IV",
        "value": 656
    }, {
        "label": "SUPERVISOR OPER. INTERNACIONAL V",
        "value": 657
    }, {
        "label": "SUPERVISOR OPER. INTERNACIONAL VI",
        "value": 658
    }, {
        "label": "SUPERVISOR OPER. NACIONAL  I",
        "value": 522
    }, {
        "label": "SUPERVISOR OPER. NACIONAL AÉREO",
        "value": 570
    }, {
        "label": "SUPERVISOR OPER. NACIONAL II",
        "value": 146
    }, {
        "label": "SUPERVISOR OPER. NACIONAL III",
        "value": 536
    }, {
        "label": "SUPERVISOR OPER. NACIONAL IV",
        "value": 214
    }, {
        "label": "SUPERVISOR OPER. NACIONAL V",
        "value": 577
    }, {
        "label": "SUPERVISOR OPER. NACIONAL VI",
        "value": 270
    }, {
        "label": "SUPERVISOR OPER. RODOVIARIAS",
        "value": 512
    }, {
        "label": "SUPERVISOR OPERAÇÃO NACIONAL RODOVIÁRIO ",
        "value": 759
    }, {
        "label": "SUPERVISOR OPERACIONAL",
        "value": 793
    }, {
        "label": "SUPERVISOR PRODUTO I",
        "value": 706
    }, {
        "label": "SUPERVISOR PRODUTO II",
        "value": 707
    }, {
        "label": "SUPERVISOR PRODUTO III",
        "value": 708
    }, {
        "label": "SUPERVISOR PRODUTO IV",
        "value": 709
    }, {
        "label": "SUPERVISOR PRODUTO V",
        "value": 710
    }, {
        "label": "SUPERVISOR PRODUTO VI",
        "value": 711
    }, {
        "label": "SUPERVISOR PROMOCOES",
        "value": 452
    }, {
        "label": "SUPERVISOR QUALIDADE",
        "value": 842
    }, {
        "label": "SUPERVISOR REMUNERAÇÃO BENEFICIOS II",
        "value": 343
    }, {
        "label": "SUPERVISOR REMUNERAÇÃO BENEFICIOS III",
        "value": 637
    }, {
        "label": "SUPERVISOR REMUNERAÇÃO BENEFICIOS VI",
        "value": 640
    }, {
        "label": "SUPERVISOR REMUNERAÇÃO E BENEFICIOS I",
        "value": 635
    }, {
        "label": "SUPERVISOR REMUNERAÇÃO E BENEFÍCIOS IV",
        "value": 638
    }, {
        "label": "SUPERVISOR REMUNERAÇÃO E BENEFICIOS V",
        "value": 639
    }, {
        "label": "SUPERVISOR SUPORTE TECNICO",
        "value": 752
    }, {
        "label": "SUPERVISOR T & D I",
        "value": 546
    }, {
        "label": "SUPERVISOR T & D II",
        "value": 348
    }, {
        "label": "SUPERVISOR T & D III",
        "value": 641
    }, {
        "label": "SUPERVISOR T & D IV",
        "value": 642
    }, {
        "label": "SUPERVISOR T & D V",
        "value": 643
    }, {
        "label": "SUPERVISOR T & D VI",
        "value": 644
    }, {
        "label": "SUPERVISOR TESOURARIA",
        "value": 244
    }, {
        "label": "SUPERVISOR VENDAS INTERNACIONAL",
        "value": 798
    }, {
        "label": "SUPORTE AO SITE",
        "value": 693
    }, {
        "label": "TAXISTA",
        "value": 835
    }, {
        "label": "TECNICO DE CUSTOS",
        "value": 489
    }, {
        "label": "TECNICO TELEFONIA",
        "value": 815
    }, {
        "label": "TELEFONISTA",
        "value": 455
    }, {
        "label": "TELEOPERADOR",
        "value": 873
    }, {
        "label": "TRAINEE",
        "value": 757
    }, {
        "label": "VICE PRESIDENTE",
        "value": 817
    }, {
        "label": "VICE PRESIDENTE COMERCIAL",
        "value": 741
    }, {
        "label": "VICE PRESIDENTE CONSELHO CONSULTIVO",
        "value": 826
    }, {
        "label": "VICE PRESIDENTE DO CONSELHO ADM.",
        "value": 824
    }, {
        "label": "WEB DESIGNER",
        "value": 874
    }];

    this.maritalStatus = [{
        label: 'Solteiro(a)', value: 1
    }, {
        label: 'Casado(a)', value: 2
    }, {
        label: 'Viúvo(a)', value: 3
    }, {
        label: 'Divorciado(a)', value: 4
    }, {
        label: 'Separado(a)', value: 5
    }, {
        label: 'Amasiado(a)', value: 6
    }, {
        label: 'Outros', value: 7
    }, ];

    this.occupations = [{
        label: 'Profissional Liberal', value: 1
    }, {
        label: 'Assalariado', value: 2
    }, {
        label: 'Empresário', value: 3
    }, {
        label: 'Aposentado', value: 4
    }, {
        label: 'Dona de casa', value: 5
    }, {
        label: 'Estudante', value: 6
    }];

    this.addressTypes = [{
        label : 'Própria', value: 0
    },{
        label : 'Alugada', value: 1
    },{
        label : 'Família', value: 2
    },{
        label : 'Financiada', value: 4
    }];

    this.bankOptions = [{
        "label": "BANCO A.J. RENNER S.A.",
        "value": 654
    }, {
        "label": "BANCO ABB S.A.",
        "value": 61
    }, {
        "label": "BANCO ABC-BRASIL S.A.",
        "value": 246
    }, {
        "label": "BANCO ABN AMRO S.A.",
        "value": 356
    }, {
        "label": "BANCO ALFA S.A.",
        "value": 25
    }, {
        "label": "BANCO ALVORADA S.A.",
        "value": 641
    }, {
        "label": "BANCO ARBI S.A.",
        "value": 213
    }, {
        "label": "BANCO BANERJ S.A.",
        "value": 29
    }, {
        "label": "BANCO BANESTADO S.A.",
        "value": 38
    }, {
        "label": "BANCO BANIF PRIMUS S.A.",
        "value": 719
    }, {
        "label": "BANCO BARCLAYS S.A.",
        "value": 740
    }, {
        "label": "BANCO BBM S.A.",
        "value": 107
    }, {
        "label": "BANCO BCN S.A.",
        "value": 291
    }, {
        "label": "BANCO BEG S.A.",
        "value": 31
    }, {
        "label": "BANCO BEMGE S.A.",
        "value": 48
    }, {
        "label": "BANCO BGN S.A.",
        "value": 739
    }, {
        "label": "BANCO BMC S.A.",
        "value": 394
    }, {
        "label": "BANCO BMG S.A.",
        "value": 318
    }, {
        "label": "BANCO BNP PARIBAS BRASIL S.A.",
        "value": 752
    }, {
        "label": "BANCO BONSUCESSO S.A.",
        "value": 218
    }, {
        "label": "BANCO BRADESCO BBI S.A.",
        "value": 36
    }, {
        "label": "BANCO BRADESCO S.A.",
        "value": 237
    }, {
        "label": "BANCO BRASCAN S.A.",
        "value": 225
    }, {
        "label": "BANCO BRJ S.A.",
        "value": 915
    }, {
        "label": "BANCO CACIQUE S.A.",
        "value": 263
    }, {
        "label": "BANCO CALYON BRASIL S.A.",
        "value": 222
    }, {
        "label": "BANCO CAPITAL S.A.",
        "value": 412
    }, {
        "label": "BANCO CARGILL S.A.",
        "value": 930
    }, {
        "label": "BANCO CEDULA S.A.",
        "value": 266
    }, {
        "label": "BANCO CENTRAL DO BRASIL",
        "value": 2
    }, {
        "label": "BANCO CITIBANK S.A.",
        "value": 745
    }, {
        "label": "BANCO CLASSICO S.A.",
        "value": 241
    }, {
        "label": "BANCO CNH CAPITAL S.A.",
        "value": 932
    }, {
        "label": "BANCO COMERCIAL URUGUAI S.A.",
        "value": 753
    }, {
        "label": "BANCO COOPERATIVO DO BRASIL S.A.",
        "value": 756
    }, {
        "label": "BANCO COOPERATIVO SICREDI S.A.",
        "value": 748
    }, {
        "label": "BANCO CREDIBEL S.A.",
        "value": 721
    }, {
        "label": "BANCO CREDIT SUISSE FIRST BOSTON S.A.",
        "value": 505
    }, {
        "label": "BANCO CRUZEIRO DO SUL S.A.",
        "value": 229
    }, {
        "label": "BANCO DA AMAZONIA S.A.",
        "value": 3
    }, {
        "label": "BANCO DA PARAIBA S.A.",
        "value": 30
    }, {
        "label": "BANCO DAIMLER-CHRYSLER S.A.",
        "value": 935
    }, {
        "label": "BANCO DAYCOVAL S.A.",
        "value": 707
    }, {
        "label": "BANCO DE DESEN. DE MINAS GERAIS S.A.",
        "value": 23
    }, {
        "label": "BANCO DE DESEN. DO ESPIRITO SANTO S.A.",
        "value": 51
    }, {
        "label": "BANCO DE LA NACION ARGENTINA",
        "value": 300
    }, {
        "label": "BANCO DE LA PROVINCIA DE BUENOS AIRES",
        "value": 495
    }, {
        "label": "BANCO DE LA REPUB. ORIENTAL DEL URUGUAY",
        "value": 494
    }, {
        "label": "BANCO DE PERNAMBUCO S.A.-BANDEPE",
        "value": 24
    }, {
        "label": "BANCO DE TOKYO-MITSUBISHI BRASIL S.A.",
        "value": 456
    }, {
        "label": "BANCO DIBENS S.A.",
        "value": 214
    }, {
        "label": "BANCO DO BRASIL S.A.",
        "value": 1
    }, {
        "label": "BANCO DO ESTADO DE SANTA CATARINA S.A.",
        "value": 27
    }, {
        "label": "BANCO DO ESTADO DE SERGIPE S.A.",
        "value": 47
    }, {
        "label": "BANCO DO ESTADO DO CEARA S.A.",
        "value": 35
    }, {
        "label": "BANCO DO ESTADO DO ESPIRITO SANTO S.A.",
        "value": 21
    }, {
        "label": "BANCO DO ESTADO DO PARA S.A.",
        "value": 37
    }, {
        "label": "BANCO DO ESTADO DO PIAUI- BEP",
        "value": 39
    }, {
        "label": "BANCO DO ESTADO DO RIO GRANDE DO SUL S.A",
        "value": 41
    }, {
        "label": "BANCO DO NORDESTE DO BRASIL S.A.",
        "value": 4
    }, {
        "label": "BANCO EMBLEMA S.A.",
        "value": 743
    }, {
        "label": "BANCO FATOR S.A.",
        "value": 265
    }, {
        "label": "BANCO FIAT S.A.",
        "value": 940
    }, {
        "label": "BANCO FIBRA S.A.",
        "value": 224
    }, {
        "label": "BANCO FICRISA AXELRUD S.A.",
        "value": 200
    }, {
        "label": "BANCO FICSA S.A.",
        "value": 626
    }, {
        "label": "BANCO FININVEST S.A.",
        "value": 252
    }, {
        "label": "BANCO FORD S.A.",
        "value": 942
    }, {
        "label": "BANCO GE CAPITAL S.A.",
        "value": 233
    }, {
        "label": "BANCO GENERAL MOTORS S.A.",
        "value": 624
    }, {
        "label": "BANCO GERDAU S.A.",
        "value": 734
    }, {
        "label": "BANCO GUANABARA S.A.",
        "value": 612
    }, {
        "label": "BANCO HONDA S.A.",
        "value": 950
    }, {
        "label": "BANCO HSBC",
        "value": 399
    }, {
        "label": "BANCO IBI S.A. BANCO MÚLTIPLO",
        "value": 63
    }, {
        "label": "BANCO INDUSTRIAL DO BRASIL S.A.",
        "value": 604
    }, {
        "label": "BANCO INDUSTRIAL E COMERCIAL S.A.",
        "value": 320
    }, {
        "label": "BANCO INDUSVAL S.A.",
        "value": 653
    }, {
        "label": "BANCO INTERCAP S.A.",
        "value": 630
    }, {
        "label": "BANCO INVESTCRED UNIBANCO S.A.",
        "value": 249
    }, {
        "label": "BANCO ITAÚ BBA S.A.",
        "value": 184
    }, {
        "label": "BANCO ITAU S.A.",
        "value": 341
    }, {
        "label": "BANCO ITAUBANK S.A",
        "value": 479
    }, {
        "label": "BANCO J. SAFRA S.A.",
        "value": 42
    }, {
        "label": "BANCO J.P. MORGAN S.A.",
        "value": 376
    }, {
        "label": "BANCO JOHN DEERE S.A.",
        "value": 217
    }, {
        "label": "BANCO KEB DO BRASIL S.A.",
        "value": 757
    }, {
        "label": "BANCO LUSO BRASILEIRO S.A.",
        "value": 600
    }, {
        "label": "BANCO MATONE S.A.",
        "value": 212
    }, {
        "label": "BANCO MAXINVEST S.A.",
        "value": 720
    }, {
        "label": "BANCO MERCANTIL DE SAO PAULO S.A.",
        "value": 392
    }, {
        "label": "BANCO MERCANTIL DO BRASIL S.A.",
        "value": 389
    }, {
        "label": "BANCO MERRILL LYNCH S.A.",
        "value": 755
    }, {
        "label": "BANCO MODAL S.A.",
        "value": 746
    }, {
        "label": "BANCO MORADA S.A.",
        "value": 738
    }, {
        "label": "BANCO MULTISTOCK S.A.",
        "value": 243
    }, {
        "label": "BANCO NACIONAL DESENV.ECONOMICO E SOCIAL",
        "value": 7
    }, {
        "label": "BANCO NOSSA CAIXA NOSSO BANCO S.A.",
        "value": 151
    }, {
        "label": "BANCO OPPORTUNITY S.A.",
        "value": 45
    }, {
        "label": "BANCO OURINVEST S.A.",
        "value": 972
    }, {
        "label": "BANCO PACTUAL S.A.",
        "value": 208
    }, {
        "label": "BANCO PANAMERICANO",
        "value": 623
    }, {
        "label": "BANCO PAULISTA S.A.",
        "value": 611
    }, {
        "label": "BANCO PEBB S.A.",
        "value": 650
    }, {
        "label": "BANCO PECUNIA S.A.",
        "value": 613
    }, {
        "label": "BANCO PINE S.A.",
        "value": 643
    }, {
        "label": "BANCO POTTENCIAL S.A.",
        "value": 735
    }, {
        "label": "BANCO PROSPER S.A.",
        "value": 638
    }, {
        "label": "BANCO PSA FINANCE BRASIL S.A.",
        "value": 978
    }, {
        "label": "BANCO RABOBANK INTERNACIONAL BRASIL S.A.",
        "value": 747
    }, {
        "label": "BANCO REDE S.A.",
        "value": 980
    }, {
        "label": "BANCO REGIONAL DE DESEN.DO EXTREMO SUL",
        "value": 46
    }, {
        "label": "BANCO RENDIMENTO S.A.",
        "value": 633
    }, {
        "label": "BANCO RIBEIRAO PRETO S.A.",
        "value": 741
    }, {
        "label": "BANCO RURAL S.A.",
        "value": 453
    }, {
        "label": "BANCO SAFRA S.A.",
        "value": 422
    }, {
        "label": "BANCO SANTANDER BRASIL S.A.",
        "value": 353
    }, {
        "label": "BANCO SANTANDER MERIDIONAL S.A.",
        "value": 8
    }, {
        "label": "BANCO SANTANDER S.A.",
        "value": 33
    }, {
        "label": "BANCO SANTOS  S.A.",
        "value": 702
    }, {
        "label": "BANCO SCHAHIN S.A.",
        "value": 250
    }, {
        "label": "BANCO SOCIETE GENERALE BRASIL S.A.",
        "value": 366
    }, {
        "label": "BANCO SOFISA S.A.",
        "value": 637
    }, {
        "label": "BANCO SUDAMERIS BRASIL S.A.",
        "value": 347
    }, {
        "label": "BANCO SUL AMERICA S.A.",
        "value": 205
    }, {
        "label": "BANCO SUMITOMO MITSUI BRASILEIRO S.A.",
        "value": 464
    }, {
        "label": "BANCO TOYOTA DO BRASIL S.A.",
        "value": 985
    }, {
        "label": "BANCO TRIANGULO S.A.",
        "value": 634
    }, {
        "label": "BANCO TRICURY S.A.",
        "value": 992
    }, {
        "label": "BANCO UBS WARBURG S.A.",
        "value": 247
    }, {
        "label": "BANCO ÚNICO S.A.",
        "value": 116
    }, {
        "label": "BANCO UNION BRASIL S.A.",
        "value": 493
    }, {
        "label": "BANCO VOLKSWAGEN S.A.",
        "value": 997
    }, {
        "label": "BANCO VOLVO BRASIL S.A.",
        "value": 998
    }, {
        "label": "BANCO VOTORANTIM S.A.",
        "value": 655
    }, {
        "label": "BANCO VR S.A.",
        "value": 610
    }, {
        "label": "BANCO WESTLB DO BRASIL S.A.",
        "value": 370
    }, {
        "label": "BANCO ZOGBI S.A.",
        "value": 219
    }, {
        "label": "BANK OF AMERICA BRASIL S.A.",
        "value": 148
    }, {
        "label": "BANKPAR BANCO MULTIPLO S.A..",
        "value": 204
    }, {
        "label": "BRB - BANCO DE BRASÍLIA S.A.",
        "value": 70
    }, {
        "label": "CAIXA ECONOMICA FEDERAL",
        "value": 104
    }, {
        "label": "DEUTSCHE BANK S.A. - BANCO ALEMAO",
        "value": 487
    }, {
        "label": "DRESDNER BANK BRASIL S.A. BANCO MULTIPLO",
        "value": 751
    }, {
        "label": "DRESDNER BANK LATEINAMERIKA AG",
        "value": 210
    }, {
        "label": "GOLDMAN SACHS DO BRASIL BANCO MULTIPLO S",
        "value": 64
    }, {
        "label": "HIPERCARD BANCO MÚLTIPLO S.A.",
        "value": 62
    }, {
        "label": "ING BANK N.V.",
        "value": 492
    }, {
        "label": "LLOYDS TSB BANK PLC",
        "value": 472
    }, {
        "label": "PARANA BANCO S.A.",
        "value": 254
    }, {
        "label": "UNIBANCO UNIAO DE BANCOS BRASILEIROS S.A.",
        "value": 409
    }];

    this.incomeTypes = [{
        "label": "Aluguel",
        "value": 2
    }, {
        "label": "Pensão",
        "value": 3
    }, {
        "label": "Produção Rural",
        "value": 6
    }, {
        "label": "Prestação de Serviços",
        "value": 5
    }, {
        "label": "Outras Rendas",
        "value": 4
    }];

    this.proofOfIncome = [{
        "label": "Extrato Bancário",
        "value": "2"
    }, {
        "label": "Holerite",
        "value": "1"
    }, {
        "label": "Outra Forma",
        "value": "3"
    }];

    this.countries = [{
        "label": "AFEGANISTAO",
        "value": "AFEGANISTAO",
        "code": "AF"
    }, {
        "label": "AFRICA DO SUL",
        "value": "AFRICA DO SUL",
        "code": "ZA"
    }, {
        "label": "ALBANIA",
        "value": "ALBANIA",
        "code": "AL"
    }, {
        "label": "ALEMANHA",
        "value": "ALEMANHA",
        "code": "DE"
    }, {
        "label": "ANDORRA",
        "value": "ANDORRA",
        "code": "AD"
    }, {
        "label": "ANGOLA",
        "value": "ANGOLA",
        "code": "A0"
    }, {
        "label": "ANGUILLA",
        "value": "ANGUILLA",
        "code": "AI"
    }, {
        "label": "ANTIGUA E BARBUDA",
        "value": "ANTIGUA E BARBUDA",
        "code": "AG"
    }, {
        "label": "ANTILHAS HOLANDESAS",
        "value": "ANTILHAS HOLANDESAS",
        "code": "AN"
    }, {
        "label": "ARABIA SAUDITA",
        "value": "ARABIA SAUDITA",
        "code": "SA"
    }, {
        "label": "ARGELIA",
        "value": "ARGELIA",
        "code": "DZ"
    }, {
        "label": "ARGENTINA",
        "value": "ARGENTINA",
        "code": "AR"
    }, {
        "label": "ARMENIA",
        "value": "ARMENIA",
        "code": "AM"
    }, {
        "label": "ARUBA",
        "value": "ARUBA",
        "code": "AW"
    }, {
        "label": "AUSTRALIA",
        "value": "AUSTRALIA",
        "code": "AU"
    }, {
        "label": "AUSTRIA",
        "value": "AUSTRIA",
        "code": "AT"
    }, {
        "label": "AZERBAIDJAO",
        "value": "AZERBAIDJAO",
        "code": "AZ"
    }, {
        "label": "AQABA",
        "value": "AGABA",
        "code": "AQ"
    }, {
        "label": "BAHAMAS",
        "value": "BAHAMAS",
        "code": "BS"
    }, {
        "label": "BANGLADESH",
        "value": "BANGLADESH",
        "code": "BD"
    }, {
        "label": "BARBADOS",
        "value": "BARBADOS",
        "code": "BB"
    }, {
        "label": "BAREIN",
        "value": "BAREIN",
        "code": "BH"
    }, {
        "label": "BELARUS",
        "value": "BELARUS",
        "code": "BY"
    }, {
        "label": "BELGICA",
        "value": "BELGICA",
        "code": "BE"
    }, {
        "label": "BELIZE",
        "value": "BELIZE",
        "code": "BZ"
    }, {
        "label": "BENIN",
        "value": "BENIN",
        "code": "BJ"
    }, {
        "label": "BERMUDA",
        "value": "BERMUDA",
        "code": "BM"
    }, {
        "label": "BOLIVIA",
        "value": "BOLIVIA",
        "code": "BO"
    }, {
        "label": "BOSNIA-HERZEGOVINA",
        "value": "BOSNIA-HERZEGOVINA",
        "code": "BA"
    }, {
        "label": "BOTSWANA",
        "value": "BOTSWANA",
        "code": "BW"
    }, {
        "label": "BRASIL",
        "value": "BRASIL",
        "code": "BR"
    }, {
        "label": "BRUNEI",
        "value": "BRUNEI",
        "code": "BN"
    }, {
        "label": "BULGARIA",
        "value": "BULGARIA",
        "code": "BG"
    }, {
        "label": "BURKINA FASSO",
        "value": "BURKINA FASSO",
        "code": "BF"
    }, {
        "label": "BURUNDI",
        "value": "BURUNDI",
        "code": "BI"
    }, {
        "label": "BUTAO",
        "value": "BUTAO",
        "code": "BU"
    }, {
        "label": "CABO VERDE",
        "value": "CABO VERDE",
        "code": "CV"
    }, {
        "label": "CAMAROES",
        "value": "CAMAROES",
        "code": "CM"
    }, {
        "label": "CAMBOJA",
        "value": "CAMBOJA",
        "code": "KH"
    }, {
        "label": "CANADA",
        "value": "CANADA",
        "code": "CA"
    }, {
        "label": "CATAR",
        "value": "CATAR",
        "code": "QA"
    }, {
        "label": "CAZAQUISTAO",
        "value": "CAZAQUISTAO",
        "code": "KZ"
    }, {
        "label": "CHADE",
        "value": "CHADE",
        "code": "TD"
    }, {
        "label": "CHILE",
        "value": "CHILE",
        "code": "CL"
    }, {
        "label": "CHINA",
        "value": "CHINA",
        "code": "CN"
    }, {
        "label": "CHIPRE",
        "value": "CHIPRE",
        "code": "CY"
    }, {
        "label": "CINGAPURA",
        "value": "CINGAPURA",
        "code": "SG"
    }, {
        "label": "COLOMBIA",
        "value": "COLOMBIA",
        "code": "CO"
    }, {
        "label": "COMORES",
        "value": "COMORES",
        "code": "KM"
    }, {
        "label": "CONGO",
        "value": "CONGO",
        "code": "CG"
    }, {
        "label": "COREIA DO NORTE",
        "value": "COREIA DO NORTE",
        "code": "KP"
    }, {
        "label": "COREIA DO SUL",
        "value": "COREIA DO SUL",
        "code": "KR"
    }, {
        "label": "COSTA DO MARFIM",
        "value": "COSTA DO MARFIM",
        "code": "CI"
    }, {
        "label": "COSTA RICA",
        "value": "COSTA RICA",
        "code": "CR"
    }, {
        "label": "CROACIA",
        "value": "CROACIA",
        "code": "HR"
    }, {
        "label": "CUBA",
        "value": "CUBA",
        "code": "CU"
    }, {
        "label": "DINAMARCA",
        "value": "DINAMARCA",
        "code": "DK"
    }, {
        "label": "DJIBUTI",
        "value": "DJIBUTI",
        "code": "DJ"
    }, {
        "label": "DOMINICA",
        "value": "DOMINICA",
        "code": "DM"
    }, {
        "label": "EGITO",
        "value": "EGITO",
        "code": "EG"
    }, {
        "label": "EL SALVADOR",
        "value": "EL SALVADOR",
        "code": "SV"
    }, {
        "label": "EMIRADOS ARABES UNIDOS",
        "value": "EMIRADOS ARABES UNIDOS",
        "code": "AE"
    }, {
        "label": "EQUADOR",
        "value": "EQUADOR",
        "code": "EC"
    }, {
        "label": "ERITREIA",
        "value": "ERITREIA",
        "code": "ER"
    }, {
        "label": "ESCOCIA",
        "value": "ESCOCIA",
        "code": "IA"
    }, {
        "label": "ESLOVAQUIA",
        "value": "ESLOVAQUIA",
        "code": "SK"
    }, {
        "label": "ESLOVENIA",
        "value": "ESLOVENIA",
        "code": "SI"
    }, {
        "label": "ESPANHA",
        "value": "ESPANHA",
        "code": "ES"
    }, {
        "label": "ESTADOS UNIDOS DA AMERICA",
        "value": "ESTADOS UNIDOS DA AMERICA",
        "code": "US"
    }, {
        "label": "ESTONIA",
        "value": "ESTONIA",
        "code": "EE"
    }, {
        "label": "ETIOPIA",
        "value": "ETIOPIA",
        "code": "ET"
    }, {
        "label": "FEDERAÃ‡ÃƒO RUSSA",
        "value": "FEDERAÃ‡ÃƒO RUSSA",
        "code": "RU"
    }, {
        "label": "FIJI",
        "value": "FIJI",
        "code": "FJ"
    }, {
        "label": "FILIPINAS",
        "value": "FILIPINAS",
        "code": "FL"
    }, {
        "label": "FINLANDIA",
        "value": "FINLANDIA",
        "code": "FI"
    }, {
        "label": "FRANCA",
        "value": "FRANCA",
        "code": "FR"
    }, {
        "label": "FRANCA METROPOLITANA",
        "value": "FRANCA METROPOLITANA",
        "code": "FX"
    }, {
        "label": "GABAO",
        "value": "GABAO",
        "code": "GA"
    }, {
        "label": "GAMBIA",
        "value": "GAMBIA",
        "code": "GM"
    }, {
        "label": "GANA",
        "value": "GANA",
        "code": "GH"
    }, {
        "label": "GEORGIA",
        "value": "GEORGIA",
        "code": "GE"
    }, {
        "label": "GIBRALTAR",
        "value": "GIBRALTAR",
        "code": "GI"
    }, {
        "label": "GRA-BRETANHA",
        "value": "GRA-BRETANHA",
        "code": "GB"
    }, {
        "label": "GRECIA",
        "value": "GRECIA",
        "code": "GR"
    }, {
        "label": "GROENLANDIA",
        "value": "GROENLANDIA",
        "code": "GL"
    }, {
        "label": "GUADALUPE",
        "value": "GUADALUPE",
        "code": "GP"
    }, {
        "label": "GUADELOUPE",
        "value": "GUADELOUPE",
        "code": "GD"
    }, {
        "label": "GUAM",
        "value": "GUAM",
        "code": "GU"
    }, {
        "label": "GUATEMALA",
        "value": "GUATEMALA",
        "code": "GT"
    }, {
        "label": "GUIANA",
        "value": "GUIANA",
        "code": "GY"
    }, {
        "label": "GUIANA FRANCESA",
        "value": "GUIANA FRANCESA",
        "code": "GF"
    }, {
        "label": "GUINE",
        "value": "GUINE",
        "code": "GN"
    }, {
        "label": "GUINE EQUATORIAL",
        "value": "GUINE EQUATORIAL",
        "code": "GQ"
    }, {
        "label": "GUINE-BISSAU",
        "value": "GUINE-BISSAU",
        "code": "GW"
    }, {
        "label": "HAITI",
        "value": "HAITI",
        "code": "HT"
    }, {
        "label": "HOLANDA",
        "value": "HOLANDA",
        "code": "NL"
    }, {
        "label": "HONDURAS",
        "value": "HONDURAS",
        "code": "HN"
    }, {
        "label": "HONG KONG",
        "value": "HONG KONG",
        "code": "HK"
    }, {
        "label": "HUNGRIA",
        "value": "HUNGRIA",
        "code": "HU"
    }, {
        "label": "IEMEN",
        "value": "IEMEN",
        "code": "YE"
    }, {
        "label": "ILHA BOUVET",
        "value": "ILHA BOUVET",
        "code": "BV"
    }, {
        "label": "ILHA CHRISTMAS",
        "value": "ILHA CHRISTMAS",
        "code": "CX"
    }, {
        "label": "ILHA NORFOLK",
        "value": "ILHA NORFOLK",
        "code": "NF"
    }, {
        "label": "ILHAS CAYMAN",
        "value": "ILHAS CAYMAN",
        "code": "KY"
    }, {
        "label": "ILHAS COCOS",
        "value": "ILHAS COCOS",
        "code": "CC"
    }, {
        "label": "ILHAS COOK",
        "value": "ILHAS COOK",
        "code": "CK"
    }, {
        "label": "ILHAS DE GUERNSEY",
        "value": "ILHAS DE GUERNSEY",
        "code": "IG"
    }, {
        "label": "ILHAS DE JERSEY",
        "value": "ILHAS DE JERSEY",
        "code": "IJ"
    }, {
        "label": "ILHAS FAROE",
        "value": "ILHAS FAROE",
        "code": "FO"
    }, {
        "label": "ILHAS GEORGIA DO SUL E ILHAS SANDWICH DO",
        "value": "ILHAS GEORGIA DO SUL E ILHAS SANDWICH DO",
        "code": "GS"
    }, {
        "label": "ILHAS HEARD E MAC DONALD",
        "value": "ILHAS HEARD E MAC DONALD",
        "code": "HM"
    }, {
        "label": "ILHAS MALVINAS",
        "value": "ILHAS MALVINAS",
        "code": "FK"
    }, {
        "label": "ILHAS MARIANA",
        "value": "ILHAS MARIANA",
        "code": "MP"
    }, {
        "label": "ILHAS MARSHALL",
        "value": "ILHAS MARSHALL",
        "code": "MH"
    }, {
        "label": "ILHAS PITCAIRN",
        "value": "ILHAS PITCAIRN",
        "code": "PN"
    }, {
        "label": "ILHAS REUNIAO",
        "value": "ILHAS REUNIAO",
        "code": "RE"
    }, {
        "label": "ILHAS SALOMAO",
        "value": "ILHAS SALOMAO",
        "code": "SB"
    }, {
        "label": "ILHAS SANTA HELENA",
        "value": "ILHAS SANTA HELENA",
        "code": "SH"
    }, {
        "label": "ILHAS SVALBARD E JAN MAYEN",
        "value": "ILHAS SVALBARD E JAN MAYEN",
        "code": "SJ"
    }, {
        "label": "ILHAS TOKELAU",
        "value": "ILHAS TOKELAU",
        "code": "TK"
    }, {
        "label": "ILHAS TURKS E CAICOS",
        "value": "ILHAS TURKS E CAICOS",
        "code": "TC"
    }, {
        "label": "ILHAS VIRGENS",
        "value": "ILHAS VIRGENS",
        "code": "VI"
    }, {
        "label": "ILHAS VIRGENS BRITANICAS",
        "value": "ILHAS VIRGENS BRITANICAS",
        "code": "VG"
    }, {
        "label": "ILHAS WALLIS E FUTUNA",
        "value": "ILHAS WALLIS E FUTUNA",
        "code": "WF"
    }, {
        "label": "INDIA",
        "value": "INDIA",
        "code": "IN"
    }, {
        "label": "INDONESIA",
        "value": "INDONESIA",
        "code": "ID"
    }, {
        "label": "IRA",
        "value": "IRA",
        "code": "IR"
    }, {
        "label": "IRAQUE",
        "value": "IRAQUE",
        "code": "IQ"
    }, {
        "label": "IRLANDA",
        "value": "IRLANDA",
        "code": "IE"
    }, {
        "label": "ISLANDIA",
        "value": "ISLANDIA",
        "code": "IS"
    }, {
        "label": "ISRAEL",
        "value": "ISRAEL",
        "code": "IL"
    }, {
        "label": "ITALIA",
        "value": "ITALIA",
        "code": "IT"
    }, {
        "label": "IUGOSLAVIA",
        "value": "IUGOSLAVIA",
        "code": "YU"
    }, {
        "label": "JAMAICA",
        "value": "JAMAICA",
        "code": "JM"
    }, {
        "label": "JAPAO",
        "value": "JAPAO",
        "code": "JP"
    }, {
        "label": "JORDANIA",
        "value": "JORDANIA",
        "code": "JO"
    }, {
        "label": "KENYA (Quenia)",
        "value": "KENYA (Quenia)",
        "code": "KE"
    }, {
        "label": "KIRIBATI",
        "value": "KIRIBATI",
        "code": "KI"
    }, {
        "label": "KUWAIT",
        "value": "KUWAIT",
        "code": "WT"
    }, {
        "label": "KUWEIT",
        "value": "KUWEIT",
        "code": "KW"
    }, {
        "label": "LAOS",
        "value": "LAOS",
        "code": "LA"
    }, {
        "label": "LESOTO",
        "value": "LESOTO",
        "code": "LS"
    }, {
        "label": "LETONIA",
        "value": "LETONIA",
        "code": "LV"
    }, {
        "label": "LIBANO",
        "value": "LIBANO",
        "code": "LB"
    }, {
        "label": "LIBERIA",
        "value": "LIBERIA",
        "code": "LR"
    }, {
        "label": "LIBIA",
        "value": "LIBIA",
        "code": "LY"
    }, {
        "label": "LIECHTENSTEIN",
        "value": "LIECHTENSTEIN",
        "code": "LI"
    }, {
        "label": "LITUANIA",
        "value": "LITUANIA",
        "code": "LT"
    }, {
        "label": "LUXEMBURGO",
        "value": "LUXEMBURGO",
        "code": "LX"
    }, {
        "label": "MACAU",
        "value": "MACAU",
        "code": "MO"
    }, {
        "label": "MACEDONIA",
        "value": "MACEDONIA",
        "code": "MK"
    }, {
        "label": "MADAGASCAR",
        "value": "MADAGASCAR",
        "code": "MG"
    }, {
        "label": "MALASIA",
        "value": "MALASIA",
        "code": "MY"
    }, {
        "label": "MALAUI",
        "value": "MALAUI",
        "code": "MW"
    }, {
        "label": "MALDIVAS",
        "value": "MALDIVAS",
        "code": "MV"
    }, {
        "label": "MALI",
        "value": "MALI",
        "code": "ML"
    }, {
        "label": "MALTA",
        "value": "MALTA",
        "code": "MT"
    }, {
        "label": "MARROCOS",
        "value": "MARROCOS",
        "code": "MA"
    }, {
        "label": "MARTINICA",
        "value": "MARTINICA",
        "code": "MQ"
    }, {
        "label": "MAURICIO",
        "value": "MAURICIO",
        "code": "MU"
    }, {
        "label": "MAURITANIA",
        "value": "MAURITANIA",
        "code": "MR"
    }, {
        "label": "MAYOTTE",
        "value": "MAYOTTE",
        "code": "YT"
    }, {
        "label": "MEXICO",
        "value": "MEXICO",
        "code": "MX"
    }, {
        "label": "MIANMAR",
        "value": "MIANMAR",
        "code": "MM"
    }, {
        "label": "MICRONESIA",
        "value": "MICRONESIA",
        "code": "FM"
    }, {
        "label": "MOCAMBIQUE",
        "value": "MOCAMBIQUE",
        "code": "MZ"
    }, {
        "label": "MOLDAVIA",
        "value": "MOLDAVIA",
        "code": "MD"
    }, {
        "label": "MONACO",
        "value": "MONACO",
        "code": "MC"
    }, {
        "label": "MONGOLIA",
        "value": "MONGOLIA",
        "code": "MN"
    }, {
        "label": "MONTSERRAT",
        "value": "MONTSERRAT",
        "code": "MS"
    }, {
        "label": "NAMIBIA",
        "value": "NAMIBIA",
        "code": "NA"
    }, {
        "label": "NAURU",
        "value": "NAURU",
        "code": "NR"
    }, {
        "label": "NEPAL",
        "value": "NEPAL",
        "code": "NP"
    }, {
        "label": "NICARAGUA",
        "value": "NICARAGUA",
        "code": "NI"
    }, {
        "label": "NIGER",
        "value": "NIGER",
        "code": "NE"
    }, {
        "label": "NIGERIA",
        "value": "NIGERIA",
        "code": "NG"
    }, {
        "label": "NIUE",
        "value": "NIUE",
        "code": "NU"
    }, {
        "label": "NORUEGA",
        "value": "NORUEGA",
        "code": "NO"
    }, {
        "label": "NOVA CALEDONIA",
        "value": "NOVA CALEDONIA",
        "code": "NC"
    }, {
        "label": "NOVA ZELANDIA",
        "value": "NOVA ZELANDIA",
        "code": "NZ"
    }, {
        "label": "OMAN",
        "value": "OMAN",
        "code": "OM"
    }, {
        "label": "PALAU",
        "value": "PALAU",
        "code": "PW"
    }, {
        "label": "PANAMA",
        "value": "PANAMA",
        "code": "PA"
    }, {
        "label": "PAPUA NOVA GUINE",
        "value": "PAPUA NOVA GUINE",
        "code": "PG"
    }, {
        "label": "PAQUISTAO",
        "value": "PAQUISTAO",
        "code": "PK"
    }, {
        "label": "PARAGUAI",
        "value": "PARAGUAI",
        "code": "PY"
    }, {
        "label": "PERU",
        "value": "PERU",
        "code": "PE"
    }, {
        "label": "POLINESIA FRANCESA",
        "value": "POLINESIA FRANCESA",
        "code": "PF"
    }, {
        "label": "POLONIA",
        "value": "POLONIA",
        "code": "PL"
    }, {
        "label": "PORTO RICO",
        "value": "PORTO RICO",
        "code": "PR"
    }, {
        "label": "PORTUGAL",
        "value": "PORTUGAL",
        "code": "PT"
    }, {
        "label": "QUENIA",
        "value": "QUENIA",
        "code": "QU"
    }, {
        "label": "QUIRGUIZIA (QuirguistÃ£o)",
        "value": "QUIRGUIZIA (QuirguistÃ£o)",
        "code": "KG"
    }, {
        "label": "REINO UNIDO",
        "value": "REINO UNIDO",
        "code": "RD"
    }, {
        "label": "REPUBLICA CENTRO-AFRICANA",
        "value": "REPUBLICA CENTRO-AFRICANA",
        "code": "CF"
    }, {
        "label": "REPUBLICA DEMOCRATICA DO CONGO",
        "value": "REPUBLICA DEMOCRATICA DO CONGO",
        "code": "RC"
    }, {
        "label": "REPUBLICA DOMINICANA",
        "value": "REPUBLICA DOMINICANA",
        "code": "DO"
    }, {
        "label": "REPUBLICA TCHECA",
        "value": "REPUBLICA TCHECA",
        "code": "CZ"
    }, {
        "label": "ROMENIA",
        "value": "ROMENIA",
        "code": "RO"
    }, {
        "label": "RUANDA",
        "value": "RUANDA",
        "code": "RW"
    }, {
        "label": "SAHARA OCIDENTAL",
        "value": "SAHARA OCIDENTAL",
        "code": "EH"
    }, {
        "label": "SAMOA AMERICANA",
        "value": "SAMOA AMERICANA",
        "code": "AS"
    }, {
        "label": "SAMOA OCIDENTAL",
        "value": "SAMOA OCIDENTAL",
        "code": "WS"
    }, {
        "label": "SAN MARINO",
        "value": "SAN MARINO",
        "code": "SM"
    }, {
        "label": "SANTA LUCIA",
        "value": "SANTA LUCIA",
        "code": "LC"
    }, {
        "label": "SAO CRISTOVAO E NEVIS",
        "value": "SAO CRISTOVAO E NEVIS",
        "code": "KN"
    }, {
        "label": "SAO PIERRE E MIQUELON",
        "value": "SAO PIERRE E MIQUELON",
        "code": "PM"
    }, {
        "label": "SAO TOME E PRINCIPE",
        "value": "SAO TOME E PRINCIPE",
        "code": "ST"
    }, {
        "label": "SAO VICENTE E GRANADINAS",
        "value": "SAO VICENTE E GRANADINAS",
        "code": "VC"
    }, {
        "label": "SEICHELES",
        "value": "SEICHELES",
        "code": "SC"
    }, {
        "label": "SENEGAL",
        "value": "SENEGAL",
        "code": "SN"
    }, {
        "label": "SERRA LEOA",
        "value": "SERRA LEOA",
        "code": "SL"
    }, {
        "label": "SERVIA",
        "value": "SERVIA",
        "code": "RS"
    }, {
        "label": "SIRIA",
        "value": "SIRIA",
        "code": "SY"
    }, {
        "label": "SOMALIA",
        "value": "SOMALIA",
        "code": "SO"
    }, {
        "label": "SRI LANKA",
        "value": "SRI LANKA",
        "code": "LK"
    }, {
        "label": "SUAZILANDIA",
        "value": "SUAZILANDIA",
        "code": "SZ"
    }, {
        "label": "SUDAO",
        "value": "SUDAO",
        "code": "SD"
    }, {
        "label": "SUECIA",
        "value": "SUECIA",
        "code": "SU"
    }, {
        "label": "SUICA",
        "value": "SUICA",
        "code": "CH"
    }, {
        "label": "SURINAME",
        "value": "SURINAME",
        "code": "SR"
    }, {
        "label": "SUÃ‰CIA",
        "value": "SUÃ‰CIA",
        "code": "SE"
    }, {
        "label": "SWAZILAND",
        "value": "SWAZILAND",
        "code": "SW"
    }, {
        "label": "Santa Catarina",
        "value": "Santa Catarina",
        "code": "NT"
    }, {
        "label": "TADJIQUISTAO",
        "value": "TADJIQUISTAO",
        "code": "TJ"
    }, {
        "label": "TAILANDIA",
        "value": "TAILANDIA",
        "code": "TH"
    }, {
        "label": "TAIWAN",
        "value": "TAIWAN",
        "code": "TW"
    }, {
        "label": "TANZANIA",
        "value": "TANZANIA",
        "code": "TZ"
    }, {
        "label": "TERRITORIOS FRANCESES MERIDIONAIS",
        "value": "TERRITORIOS FRANCESES MERIDIONAIS",
        "code": "TF"
    }, {
        "label": "TIMOR LESTE",
        "value": "TIMOR LESTE",
        "code": "TP"
    }, {
        "label": "TOGO",
        "value": "TOGO",
        "code": "TG"
    }, {
        "label": "TONGA",
        "value": "TONGA",
        "code": "TO"
    }, {
        "label": "TRINIDAD E TOBAGO",
        "value": "TRINIDAD E TOBAGO",
        "code": "TT"
    }, {
        "label": "TUNISIA",
        "value": "TUNISIA",
        "code": "TN"
    }, {
        "label": "TURCOMENIA",
        "value": "TURCOMENIA",
        "code": "TM"
    }, {
        "label": "TURQUIA",
        "value": "TURQUIA",
        "code": "TR"
    }, {
        "label": "TUVALU",
        "value": "TUVALU",
        "code": "TV"
    }, {
        "label": "UCRANIA",
        "value": "UCRANIA",
        "code": "UA"
    }, {
        "label": "UGANDA",
        "value": "UGANDA",
        "code": "UG"
    }, {
        "label": "URUGUAI",
        "value": "URUGUAI",
        "code": "UY"
    }, {
        "label": "UZBEQUISTAO",
        "value": "UZBEQUISTAO",
        "code": "UZ"
    }, {
        "label": "VANUATU",
        "value": "VANUATU",
        "code": "VU"
    }, {
        "label": "VATICANO",
        "value": "VATICANO",
        "code": "VA"
    }, {
        "label": "VENEZUELA",
        "value": "VENEZUELA",
        "code": "VE"
    }, {
        "label": "VIETNA",
        "value": "VIETNA",
        "code": "VN"
    }, {
        "label": "YEMEM",
        "value": "YEMEM",
        "code": "YM"
    }, {
        "label": "ZAMBIA",
        "value": "ZAMBIA",
        "code": "ZM"
    }, {
        "label": "ZIMBABUE",
        "value": "ZIMBABUE",
        "code": "ZW"
    }];

    this.months = [{
        "label": "Janeiro",
        "value": "1"
    }, {
        "label": "Fevereiro",
        "value": "2"
    }, {
        "label": "Março",
        "value": "3"
    }, {
        "label": "Abril",
        "value": "4"
    }, {
        "label": "Maio",
        "value": "5"
    }, {
        "label": "Junho",
        "value": "6"
    }, {
        "label": "Julho",
        "value": "7"
    }, {
        "label": "Agosto",
        "value": "8"
    }, {
        "label": "Setembro",
        "value": "9"
    }, {
        "label": "Outubro",
        "value": "10"
    }, {
        "label": "Novembro",
        "value": "11"
    }, {
        "label": "Dezembro",
        "value": "12"
    }];

    this.relationshipTypes = [{
        label: 'Pai',
        value: 1
    },{
        label: 'Mãe',
        value: 2
    },{
        label: 'Irmão',
        value: 3
    },{
        label: 'Irmã',
        value: 4
    },{
        label: 'Filho',
        value: 5
    },{
        label: 'Filha',
        value: 6
    },{
        label: 'Esposo',
        value: 7
    },{
        label: 'Esposa',
        value: 8
    }];

    this.cpfTypes = [{
        value: 'Selecione'
    },{
        code: 0,
        value: 'Próprio'
    }, {
        code: 1,
        value: 'Responsável'
    }];
 
}]);